/* eslint-disable */
import type { DateTime } from 'luxon'
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Scalar Date type */
  Date: { input: DateTime; output: DateTime; }
  /** Scalar DateTime type */
  DateTime: { input: DateTime; output: DateTime; }
};

export enum AccountStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  GracePeriod = 'GRACE_PERIOD'
}

export type Achievement = {
  __typename?: 'Achievement';
  category: Category;
  distinctDayCheckinCount: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  memberId: Scalars['Int']['output'];
  nextGoal?: Maybe<Scalars['Int']['output']>;
};

export type ActivationCodeInput = {
  activationCode: Scalars['String']['input'];
  birthDate: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  wecWorksConnection?: InputMaybe<WecWorksConnectionType>;
};

export type ActiveStreaks = {
  __typename?: 'ActiveStreaks';
  best: Scalars['Int']['output'];
  current: CurrentStreak;
};

export type AddDashboardUserToChannelResponse = MutationResponse & {
  __typename?: 'AddDashboardUserToChannelResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  android: Scalars['String']['output'];
  ios: Scalars['String']['output'];
};

export type AssignPeerInput = {
  memberId: Scalars['Int']['input'];
  peerId: Scalars['Int']['input'];
};

export type AttendedOnlineMeeting = {
  __typename?: 'AttendedOnlineMeeting';
  attendedDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Audit = {
  __typename?: 'Audit';
  createdAt: Scalars['DateTime']['output'];
  dashboardUser: DashboardUser;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type AuthorizeGoogleInput = {
  code: Scalars['String']['input'];
};

export type AuthorizeZoomInput = {
  code: Scalars['String']['input'];
};

export type AvailabilityHours = {
  __typename?: 'AvailabilityHours';
  endTime: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  recurrence: Array<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
};

export type AvailabilityHoursInput = {
  endTime: Scalars['DateTime']['input'];
  recurrence: Array<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  timeZone: Scalars['String']['input'];
};

export type Barc10 = {
  __typename?: 'BARC10';
  expiresAt: Scalars['DateTime']['output'];
  shouldShow: Scalars['Boolean']['output'];
  shouldShowCard: Scalars['Boolean']['output'];
};

export type Barc10MutationResponse = MutationResponse & {
  __typename?: 'Barc10MutationResponse';
  barc10?: Maybe<Barc10Response>;
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Barc10Question = {
  __typename?: 'Barc10Question';
  body: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type Barc10Response = Barc10 | ValidationErrors;

export type Barc10ResponseInput = {
  questionId: Scalars['Int']['input'];
  response: Scalars['Int']['input'];
};

export type Barc10Survey = {
  __typename?: 'Barc10Survey';
  answers: Array<Barc10Answer>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
};

export type Barc10V3Input = {
  responses: Array<Barc10ResponseInput>;
};

export type BeginCheckoutInput = {
  birthDate: Scalars['DateTime']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type BeginCheckoutResponse = MutationResponse & {
  __typename?: 'BeginCheckoutResponse';
  checkout?: Maybe<Checkout>;
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Brand = {
  __typename?: 'Brand';
  alwaysShowDisclaimer: Scalars['Boolean']['output'];
  disclaimer: Scalars['String']['output'];
  image: Scalars['String']['output'];
  items: Array<Item>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CancelCheckoutResponse = MutationResponse & {
  __typename?: 'CancelCheckoutResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Category = {
  __typename?: 'Category';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['Int']['output'];
  groupName: CategoryGroup;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum CategoryGroup {
  Chores = 'Chores',
  /** @deprecated No longer supported */
  CourtAppointment = 'CourtAppointment',
  DeviceDowntime = 'DeviceDowntime',
  EatDrink = 'EatDrink',
  Exercise = 'Exercise',
  /** @deprecated No longer supported */
  Finance = 'Finance',
  /** @deprecated No longer supported */
  Gateway = 'Gateway',
  /** @deprecated No longer supported */
  GroupSession = 'GroupSession',
  GroupSupport = 'GroupSupport',
  HealthManagement = 'HealthManagement',
  Hobbies = 'Hobbies',
  /** @deprecated No longer supported */
  Housing = 'Housing',
  Hygiene = 'Hygiene',
  Job = 'Job',
  /** @deprecated No longer supported */
  MedicallyAssistedTreatment = 'MedicallyAssistedTreatment',
  Meditation = 'Meditation',
  /** @deprecated No longer supported */
  Meeting = 'Meeting',
  OneOnOne = 'OneOnOne',
  /** @deprecated No longer supported */
  OnlineMeeting = 'OnlineMeeting',
  Other = 'Other',
  ReadWrite = 'ReadWrite',
  ReligionSpirituality = 'ReligionSpirituality',
  School = 'School',
  Sleep = 'Sleep',
  SocialTime = 'SocialTime',
  /** @deprecated No longer supported */
  UrinalysisAppointment = 'UrinalysisAppointment',
  WEcOnlineMeetings = 'WEcOnlineMeetings',
  WEcPeerSupport = 'WEcPeerSupport'
}

export type Challenge = {
  __typename?: 'Challenge';
  amount: Scalars['Int']['output'];
  challengeName: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  earnedProgress: Scalars['Int']['output'];
  earnedReward?: Maybe<EarnedReward>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  goalType: ChallengeGoalType;
  id: Scalars['Int']['output'];
  isTutorial: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  selfCareGoal: Scalars['Int']['output'];
  selfCareProgress: Scalars['Int']['output'];
  startsAt: Scalars['DateTime']['output'];
  supportGoal: Scalars['Int']['output'];
  supportProgress: Scalars['Int']['output'];
};

export enum ChallengeGoalType {
  RoutineCheckin = 'RoutineCheckin',
  RoutineCreation = 'RoutineCreation'
}

export type ChallengeStructure = {
  __typename?: 'ChallengeStructure';
  amount: Scalars['Int']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  selfCareGoal: Scalars['Int']['output'];
  supportGoal: Scalars['Int']['output'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CheckMutationResponse = MutationResponse & {
  __typename?: 'CheckMutationResponse';
  checkin: CheckinResponse;
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Checkin = {
  __typename?: 'Checkin';
  checkInAt?: Maybe<Scalars['DateTime']['output']>;
  checkOutAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<CheckinLocation>;
  notPresentWarningSeen: Scalars['Boolean']['output'];
  routine: Routine;
  timeWarningSeen: Scalars['Boolean']['output'];
};

export type CheckinLocation = {
  __typename?: 'CheckinLocation';
  accuracy: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CheckinLocationInput = {
  accuracy: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CheckinResponse = Checkin | ValidationErrors;

export type Checkout = {
  __typename?: 'Checkout';
  customerId: Scalars['String']['output'];
  ephemeralKey?: Maybe<Scalars['String']['output']>;
  setupIntentClientSecret?: Maybe<Scalars['String']['output']>;
  setupIntentId?: Maybe<Scalars['String']['output']>;
};

export type ContactPermission = {
  __typename?: 'ContactPermission';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Contract = {
  __typename?: 'Contract';
  durationOfMessaging?: Maybe<Scalars['Int']['output']>;
  durationOfRewards?: Maybe<Scalars['Int']['output']>;
  eligibleMemberCount?: Maybe<Scalars['Int']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  enrollmentEndsAt?: Maybe<Scalars['Date']['output']>;
  enrollmentStartsAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  planYearEarningsLimit?: Maybe<Scalars['Int']['output']>;
  planYearStartsAt?: Maybe<Scalars['Date']['output']>;
  requiresReferral: Scalars['Boolean']['output'];
  rewardsPlan?: Maybe<RewardsPlan>;
  rewardsPlanId?: Maybe<Scalars['Int']['output']>;
  startingBalance: Scalars['Int']['output'];
  tangoBrandKeys: Array<Scalars['String']['output']>;
  treatmentProviders: Array<TreatmentProvider>;
  type?: Maybe<ContractType>;
};

export type ContractInput = {
  durationOfMessaging?: InputMaybe<Scalars['Int']['input']>;
  durationOfRewards?: InputMaybe<Scalars['Int']['input']>;
  eligibleMemberCount?: InputMaybe<Scalars['Int']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  enrollmentEndsAt?: InputMaybe<Scalars['Date']['input']>;
  enrollmentStartsAt?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  planYearEarningsLimit?: InputMaybe<Scalars['Int']['input']>;
  planYearStartsAt?: InputMaybe<Scalars['Date']['input']>;
  requiresReferral: Scalars['Boolean']['input'];
  rewardsPlanId: Scalars['Int']['input'];
  startingBalance: Scalars['Int']['input'];
  type?: InputMaybe<ContractType>;
};

export type ContractMutationResponse = MutationResponse & {
  __typename?: 'ContractMutationResponse';
  code: Scalars['Int']['output'];
  contract?: Maybe<ContractResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ContractResponse = Contract | ValidationErrors;

export enum ContractType {
  HealthPlan = 'HealthPlan',
  ServiceProvider = 'ServiceProvider',
  WecWorks = 'WecWorks'
}

export type CreateAccountMutationResponse = MutationResponse & {
  __typename?: 'CreateAccountMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  session?: Maybe<SessionResponse>;
  success: Scalars['Boolean']['output'];
};

export type CreateAccountV5Input = {
  activationFields?: InputMaybe<ActivationCodeInput>;
  languageTag?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBulkRoutineV2Input = {
  memberIds: Array<Scalars['Int']['input']>;
  routine: CreateRoutineV2Input;
};

export type CreateBulkRoutineV2Response = {
  __typename?: 'CreateBulkRoutineV2Response';
  createdRoutines: Array<Routine>;
  failedMemberIds: Array<Scalars['Int']['output']>;
};

export type CreateCheckinInput = {
  checkInAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateV2?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<CheckinLocationInput>;
  notPresentWarningSeen?: InputMaybe<Scalars['Boolean']['input']>;
  routineId: Scalars['Int']['input'];
  timeWarningSeen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDashboardUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CreateDashboardUserResponse = MutationResponse & {
  __typename?: 'CreateDashboardUserResponse';
  code: Scalars['Int']['output'];
  dashboardUser?: Maybe<DashboardUserResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateFeatureInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type CreateFeatureResponse = {
  __typename?: 'CreateFeatureResponse';
  feature?: Maybe<Feature>;
};

export type CreateRedeemedRewardInput = {
  amount: Scalars['Int']['input'];
  utid: Scalars['String']['input'];
};

export type CreateRewardsCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['Int']['input'];
  distributionMethod?: InputMaybe<DistributionMethod>;
  redemptionLimit: Scalars['Int']['input'];
  startingBalance?: InputMaybe<Scalars['Int']['input']>;
  treatmentProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRewardsCodesInput = {
  contractId: Scalars['Int']['input'];
  count: Scalars['Int']['input'];
  distributionMethod?: InputMaybe<DistributionMethod>;
  redemptionLimit: Scalars['Int']['input'];
  startingBalance?: InputMaybe<Scalars['Int']['input']>;
  treatmentProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRewardsCodesResponse = MutationResponse & {
  __typename?: 'CreateRewardsCodesResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  rewardsCodes?: Maybe<Array<RewardsCode>>;
  success: Scalars['Boolean']['output'];
};

export type CreateRewardsPlanInput = {
  barc10Amount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  segments: Array<RewardsPlanSegmentInput>;
  surveyAmount: Scalars['Int']['input'];
};

export type CreateRoutineV2Input = {
  anytime?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  dashboardUserId?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<RoutineLocationInput>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  openaiId?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<RoutineOrigin>;
  publicMeetingId?: InputMaybe<Scalars['Int']['input']>;
  recurrence: Array<Scalars['String']['input']>;
  reminders?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<RoutineStatusType>;
  wellnessGoalIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateSubscriptionInput = {
  priceId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['String']['input']>;
  setupIntentId: Scalars['String']['input'];
};

export type CreateTreatmentProviderInput = {
  contractId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CurrentStreak = {
  __typename?: 'CurrentStreak';
  count: Scalars['Int']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type DashboardNotification = {
  __typename?: 'DashboardNotification';
  createdAt: Scalars['DateTime']['output'];
  event: DashboardNotificationEvent;
  id: Scalars['Int']['output'];
  member: Member;
  memberId: Scalars['Int']['output'];
  seen: Scalars['Boolean']['output'];
};

export enum DashboardNotificationEvent {
  AccountDeactivated = 'AccountDeactivated',
  AccountDeleted = 'AccountDeleted',
  GoalCreated = 'GoalCreated',
  GoalDeleted = 'GoalDeleted',
  PaymentFailed = 'PaymentFailed',
  PeerAssigned = 'PeerAssigned',
  SubscriptionCanceled = 'SubscriptionCanceled'
}

export type DashboardUser = {
  __typename?: 'DashboardUser';
  active: Scalars['Boolean']['output'];
  activeMemberCount?: Maybe<Scalars['Int']['output']>;
  appDisplayName: Scalars['String']['output'];
  appointmentSlots: Array<DateAppointmentSlots>;
  availabilityHours?: Maybe<AvailabilityHours>;
  bio?: Maybe<Scalars['String']['output']>;
  bioSpanish?: Maybe<Scalars['String']['output']>;
  calendarLink?: Maybe<Scalars['String']['output']>;
  cumulativeEngagementDuration?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  engagedMemberCount?: Maybe<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  googleConnected: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inactiveMemberCount?: Maybe<Scalars['Int']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  peerStateCertifications: Array<PeerStateCertification>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  timeZone?: Maybe<Scalars['String']['output']>;
  vacationMessage?: Maybe<VacationMessage>;
  zoomConnected: Scalars['Boolean']['output'];
};


export type DashboardUserAppointmentSlotsArgs = {
  duration?: InputMaybe<Scalars['Int']['input']>;
};


export type DashboardUserCumulativeEngagementDurationArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type DashboardUserResponse = DashboardUser | ValidationErrors;

export type DateAppointmentSlots = {
  __typename?: 'DateAppointmentSlots';
  date: Scalars['Date']['output'];
  startTimes: Array<Scalars['DateTime']['output']>;
};

export type DeleteAccountInput = {
  _?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAccountResponse = MutationResponse & {
  __typename?: 'DeleteAccountResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteCheckinInput = {
  id: Scalars['Int']['input'];
};

export type DeleteCheckinResponse = {
  __typename?: 'DeleteCheckinResponse';
  memberV2: Member;
};

export type DeleteDeviceInput = {
  deviceId: Scalars['String']['input'];
};

export type DeleteDeviceResponse = {
  __typename?: 'DeleteDeviceResponse';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteMemberBenefitsInput = {
  memberId: Scalars['Int']['input'];
};

export type DeleteRecurrenceInputV2 = {
  deleteFuture: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
  startsAt: Scalars['DateTime']['input'];
};

export type DeleteRecurrenceMutationResponse = MutationResponse & {
  __typename?: 'DeleteRecurrenceMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  routine?: Maybe<RoutineResponse>;
  success: Scalars['Boolean']['output'];
};

export type DeleteRewardsCodesInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type DeleteRoutineMutationResponse = MutationResponse & {
  __typename?: 'DeleteRoutineMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  routine?: Maybe<RoutineResponse>;
  success: Scalars['Boolean']['output'];
};

export type DeleteRoutineV2Input = {
  id: Scalars['Int']['input'];
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeletedMessage = {
  __typename?: 'DeletedMessage';
  deletedAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  messageSentAt: Scalars['DateTime']['output'];
  messageText: Scalars['String']['output'];
  receivedBy: Member;
  sentBy: DashboardUser;
};

export type DestroyFeatureInput = {
  key: Scalars['String']['input'];
};

export type DestroyFeatureResponse = {
  __typename?: 'DestroyFeatureResponse';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export enum DistributionMethod {
  CustomerService = 'CustomerService',
  Email = 'Email',
  Letter = 'Letter',
  Multiuse = 'Multiuse',
  Other = 'Other',
  PrintedTicket = 'PrintedTicket',
  SlickText = 'SlickText',
  Upcall = 'Upcall'
}

export type EarnedReward = {
  __typename?: 'EarnedReward';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type EditRewardsPlanInput = {
  barc10Amount: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  segments: Array<RewardsPlanSegmentInput>;
  surveyAmount: Scalars['Int']['input'];
};

export type EmailAttendanceReportInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  routineIds: Array<Scalars['Int']['input']>;
};

export type EmailAttendanceReportResponse = MutationResponse & {
  __typename?: 'EmailAttendanceReportResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Engagement = {
  __typename?: 'Engagement';
  actions?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  goalProgress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  member: Member;
  notes?: Maybe<Scalars['String']['output']>;
  peer: DashboardUser;
  planChanges?: Maybe<Scalars['String']['output']>;
  referrals?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  successful: Scalars['Boolean']['output'];
  type: EngagementType;
};

export type EngagementInput = {
  actions?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  goalProgress?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  planChanges?: InputMaybe<Scalars['String']['input']>;
  referrals?: InputMaybe<Scalars['String']['input']>;
  startedAt: Scalars['DateTime']['input'];
  successful: Scalars['Boolean']['input'];
  type: EngagementType;
};

export type EngagementMutationResponse = MutationResponse & {
  __typename?: 'EngagementMutationResponse';
  code: Scalars['Int']['output'];
  engagement?: Maybe<EngagementResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EngagementResponse = Engagement | ValidationErrors;

export enum EngagementType {
  InAppMessaging = 'InAppMessaging',
  InPerson = 'InPerson',
  Other = 'Other',
  PhoneCall = 'PhoneCall',
  TextMessaging = 'TextMessaging',
  VideoCall = 'VideoCall'
}

export type Feature = {
  __typename?: 'Feature';
  comment?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  minVersion?: Maybe<Scalars['String']['output']>;
  retiredVersion?: Maybe<Scalars['String']['output']>;
  rolloutPhase: RolloutPhase;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type FeatureOverride = {
  __typename?: 'FeatureOverride';
  key: Scalars['String']['output'];
  memberIds: Array<Scalars['Int']['output']>;
};

export type FeatureRetireInput = {
  key: Scalars['String']['input'];
};

export type FeatureRolloutInput = {
  key: Scalars['String']['input'];
  rolloutPhase: RolloutPhase;
};

export type FixedItem = Item & {
  __typename?: 'FixedItem';
  faceValue: Scalars['Int']['output'];
  rewardName: Scalars['String']['output'];
  type: ValueType;
  utid: Scalars['String']['output'];
};

export type GetClaimCodeInput = {
  rewardId: Scalars['Int']['input'];
};

export type GetClaimCodeResponse = {
  __typename?: 'GetClaimCodeResponse';
  claimCode?: Maybe<Scalars['String']['output']>;
};

export type GratitudeList = {
  __typename?: 'GratitudeList';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type GratitudeListInput = {
  text: Scalars['String']['input'];
};

export type GratitudeListMutationResponse = MutationResponse & {
  __typename?: 'GratitudeListMutationResponse';
  code: Scalars['Int']['output'];
  gratitudeList?: Maybe<GratitudeListResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GratitudeListResponse = GratitudeList | ValidationErrors;

export type HealthPlan = {
  __typename?: 'HealthPlan';
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type HealthPlanInfo = {
  __typename?: 'HealthPlanInfo';
  healthPlan: SupportedHealthPlan;
  id: Scalars['Int']['output'];
  insuranceId: Scalars['String']['output'];
};

export type InspirationalQuote = {
  __typename?: 'InspirationalQuote';
  author: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  quote: Scalars['String']['output'];
  saved: Scalars['Boolean']['output'];
};

export type InspirationalQuoteMutationResponse = MutationResponse & {
  __typename?: 'InspirationalQuoteMutationResponse';
  code: Scalars['Int']['output'];
  inspirationalQuote?: Maybe<InspirationalQuote>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InsuranceProfileInput = {
  insuranceProviderId?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['String']['input'];
};

export type InsuranceState = {
  __typename?: 'InsuranceState';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Intake = {
  __typename?: 'Intake';
  complementaryRecoveryPlan?: Maybe<Scalars['String']['output']>;
  contactNotes?: Maybe<Scalars['String']['output']>;
  engagementFrequency?: Maybe<Scalars['Int']['output']>;
  engagementFrequencyInterval?: Maybe<IntakeEngagementFrequencyInterval>;
  hopesAndDreams?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  strengthsAndInterests?: Maybe<Scalars['String']['output']>;
  supportivePeople: Array<SupportivePerson>;
  textOkay?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  voicemailOkay?: Maybe<Scalars['Boolean']['output']>;
};

export enum IntakeEngagementFrequencyInterval {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week'
}

export type IntakeInput = {
  complementaryRecoveryPlan?: InputMaybe<Scalars['String']['input']>;
  contactNotes?: InputMaybe<Scalars['String']['input']>;
  engagementFrequency?: InputMaybe<Scalars['Int']['input']>;
  engagementFrequencyInterval?: InputMaybe<IntakeEngagementFrequencyInterval>;
  hopesAndDreams?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  strengthsAndInterests?: InputMaybe<Scalars['String']['input']>;
  supportivePeople?: InputMaybe<Array<SupportivePersonInput>>;
  textOkay?: InputMaybe<Scalars['Boolean']['input']>;
  voicemailOkay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Item = {
  rewardName: Scalars['String']['output'];
  type: ValueType;
  utid: Scalars['String']['output'];
};

export type JoinMeetingInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  publicMeetingId: Scalars['Int']['input'];
};

export type JoinMeetingResponse = MutationResponse & {
  __typename?: 'JoinMeetingResponse';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Location = {
  __typename?: 'Location';
  formattedAddress: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
};

export type MarkDashboardNotificationsAsSeenMutationResponse = MutationResponse & {
  __typename?: 'MarkDashboardNotificationsAsSeenMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  notifications?: Maybe<Array<DashboardNotification>>;
  success: Scalars['Boolean']['output'];
};

export type MarkEarnedRewardsAsSeenResponse = {
  __typename?: 'MarkEarnedRewardsAsSeenResponse';
  memberV2: Member;
};

export type Member = {
  __typename?: 'Member';
  accountDeactivationDate?: Maybe<Scalars['DateTime']['output']>;
  accountEnabled: Scalars['Boolean']['output'];
  accountStatus: AccountStatus;
  achievementForCategory?: Maybe<Achievement>;
  achievements: Array<Achievement>;
  activeStreaks: ActiveStreaks;
  attendedOnlineMeetings: Array<AttendedOnlineMeeting>;
  barc10?: Maybe<Barc10>;
  benefits?: Maybe<MemberBenefits>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  challenges: Array<Challenge>;
  checkins: Array<Checkin>;
  contactPermissions: Array<ContactPermission>;
  createdAt: Scalars['DateTime']['output'];
  csNotes?: Maybe<Scalars['String']['output']>;
  currentChallengeV2?: Maybe<Challenge>;
  eligibilityLastChecked?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  engaged: Scalars['Boolean']['output'];
  engagements: Array<Engagement>;
  firstName?: Maybe<Scalars['String']['output']>;
  gratitudeLists: Array<GratitudeList>;
  hasActiveBenefits: Scalars['Boolean']['output'];
  hasActiveEligibility?: Maybe<Scalars['Boolean']['output']>;
  hasPrss: Scalars['Boolean']['output'];
  healthPlanInfo?: Maybe<HealthPlanInfo>;
  id: Scalars['Int']['output'];
  intake?: Maybe<Intake>;
  isFreeMember: Scalars['Boolean']['output'];
  isNewMember: Scalars['Boolean']['output'];
  languageTag?: Maybe<Scalars['String']['output']>;
  lastConcludedChallenge?: Maybe<Challenge>;
  lastDaysUsedSubstanceResponse?: Maybe<Scalars['Int']['output']>;
  lastKnownTimeZone: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastOutreach?: Maybe<Scalars['DateTime']['output']>;
  mesNotes?: Maybe<Scalars['String']['output']>;
  messaging?: Maybe<Messaging>;
  messagingEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nextStandardSurvey?: Maybe<NextStandardSurvey>;
  outreachCount: Scalars['Int']['output'];
  peerChangeRequest?: Maybe<PeerChangeRequest>;
  peerSupportQuestionnaire?: Maybe<PeerSupportQuestionnaire>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  problematicSubstancesV2?: Maybe<Array<ProblematicSubstance>>;
  progressDate?: Maybe<Scalars['Date']['output']>;
  pronouns: Array<Pronoun>;
  randomStrength?: Maybe<MemberStrengthResponse>;
  recentLocations: Array<Location>;
  recurrencesV3: Array<RecurrenceV3>;
  redeemedRewards: Array<RedeemedReward>;
  releasesOfInformation: Array<ReleaseOfInformation>;
  rewardsBalance: Scalars['Int']['output'];
  rewardsCode?: Maybe<RewardsCode>;
  rewardsEnabled: Scalars['Boolean']['output'];
  rewardsPlan?: Maybe<RewardsPlan>;
  routines: Array<Routine>;
  savedQuotes: Array<InspirationalQuote>;
  standardSurveys: Array<StandardSurveyV2>;
  starred: Scalars['Boolean']['output'];
  strengths: Array<Strength>;
  subscription?: Maybe<PaidSubscription>;
  timeTravel?: Maybe<Scalars['DateTime']['output']>;
  timeZone: Scalars['String']['output'];
  totalEarned: Scalars['Int']['output'];
  totalEngagementDuration?: Maybe<Scalars['Int']['output']>;
  treatmentProvider?: Maybe<TreatmentProvider>;
  unseenEarnedRewardsCount: Scalars['Int']['output'];
  wellnessGoals: Array<WellnessGoal>;
};


export type MemberAchievementForCategoryArgs = {
  categoryId: Scalars['Int']['input'];
};


export type MemberAttendedOnlineMeetingsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberChallengesArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberCheckinsArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberEngagementsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberGratitudeListsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MemberRecentLocationsArgs = {
  limit: Scalars['Int']['input'];
};


export type MemberRecurrencesV3Args = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone: Scalars['String']['input'];
};


export type MemberRoutinesArgs = {
  input?: InputMaybe<RoutinesInput>;
};


export type MemberSavedQuotesArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type MemberBenefits = {
  __typename?: 'MemberBenefits';
  activatedAt: Scalars['DateTime']['output'];
  channelLastReadAt?: Maybe<Scalars['DateTime']['output']>;
  contract?: Maybe<Contract>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lastMessageSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessageSentBy?: Maybe<MessageSentByRole>;
  maxPotentialRewards: Scalars['Int']['output'];
  messagingChannelUrl?: Maybe<Scalars['String']['output']>;
  messagingEndsAt?: Maybe<Scalars['DateTime']['output']>;
  peer?: Maybe<DashboardUser>;
  rewardsEndsAt?: Maybe<Scalars['DateTime']['output']>;
  sentMessageCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MemberBenefitsFilters = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
  peerId?: InputMaybe<Scalars['Int']['input']>;
};

export type MemberBenefitsMutationResponse = MutationResponse & {
  __typename?: 'MemberBenefitsMutationResponse';
  code: Scalars['Int']['output'];
  memberBenefits?: Maybe<MemberBenefitsResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MemberBenefitsResponse = MemberBenefits | ValidationErrors;

export type MemberContactPermissionsInput = {
  contactPermissionsId: Scalars['Int']['input'];
};

export type MemberMutationResponse = MutationResponse & {
  __typename?: 'MemberMutationResponse';
  code: Scalars['Int']['output'];
  member?: Maybe<MemberResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MemberPronounInput = {
  customResponse?: InputMaybe<Scalars['String']['input']>;
  pronounsId: Scalars['Int']['input'];
};

export type MemberResponse = Member | ValidationErrors;

export type MemberStrengthResponse = {
  __typename?: 'MemberStrengthResponse';
  id: Scalars['Int']['output'];
  response: Scalars['String']['output'];
  strengthPrompt: Strength;
};

export type MemberSubstanceInput = {
  freeFormResponse?: InputMaybe<Scalars['String']['input']>;
  problematicSubstanceId: Scalars['Int']['input'];
};

export enum MessageSentByRole {
  Admin = 'Admin',
  Member = 'Member',
  MemberEngagementSpecialist = 'MemberEngagementSpecialist',
  Peer = 'Peer',
  PeerSupervisor = 'PeerSupervisor'
}

export type Messaging = {
  __typename?: 'Messaging';
  messagingId?: Maybe<Scalars['String']['output']>;
};

export enum MessagingBenefitStatus {
  Active = 'Active',
  Expired = 'Expired'
}

export type Mutation = {
  __typename?: 'Mutation';
  addDashboardUserToChannel: AddDashboardUserToChannelResponse;
  answerBarc10V3: Barc10MutationResponse;
  answerPeerSupportQuestionnaire: MemberMutationResponse;
  answerStandardSurvey: Scalars['Boolean']['output'];
  assignPeer: MemberBenefitsMutationResponse;
  authorizeGoogle: UpdateDashboardUserResponse;
  authorizeZoom: UpdateDashboardUserResponse;
  beginCheckout: BeginCheckoutResponse;
  cancelCheckout: CancelCheckoutResponse;
  cancelSubscription: SubscriptionMutationResponse;
  changeDashboardUserPassword: UpdateDashboardUserResponse;
  createAccountV5: CreateAccountMutationResponse;
  createBulkRoutineV2?: Maybe<CreateBulkRoutineV2Response>;
  createCheckinV3: CheckMutationResponse;
  createContractV2: ContractMutationResponse;
  createDashboardUser: CreateDashboardUserResponse;
  createEngagement: EngagementMutationResponse;
  createFeature?: Maybe<CreateFeatureResponse>;
  createGratitudeList: GratitudeListMutationResponse;
  createOutreach: OutreachMutationResponse;
  createRedeemedRewardV2: Member;
  createReleaseOfInformation: ReleaseOfInformationMutationResponse;
  createRewardsCode: RewardsCodeMutationResponse;
  createRewardsCodes: CreateRewardsCodesResponse;
  createRewardsPlan: RewardsPlanResponse;
  createRoutineV2: Routine;
  createSubscription: SubscriptionMutationResponse;
  createTreatmentProvider: TreatmentProviderMutationResponse;
  createWellnessGoal: WellnessGoalMutationResponse;
  deleteAccount: DeleteAccountResponse;
  deleteCheckin: DeleteCheckinResponse;
  deleteDevice?: Maybe<DeleteDeviceResponse>;
  deleteEngagement: EngagementMutationResponse;
  deleteGratitudeList: GratitudeListMutationResponse;
  deleteMemberBenefits: MemberMutationResponse;
  deleteOutreach: OutreachMutationResponse;
  deleteRecurrence: DeleteRecurrenceMutationResponse;
  deleteReleaseOfInformation: ReleaseOfInformationMutationResponse;
  deleteRewardsCodes: RewardsCodesMutationResponse;
  deleteRoutineV2: DeleteRoutineMutationResponse;
  deleteTreatmentProvider: TreatmentProviderMutationResponse;
  deleteWellnessGoal: WellnessGoalMutationResponse;
  destroyFeature?: Maybe<DestroyFeatureResponse>;
  dismissBARC10CardV2?: Maybe<Barc10>;
  dismissBarc10?: Maybe<Barc10>;
  dismissStandardSurvey?: Maybe<NextStandardSurvey>;
  dismissStandardSurveyCard?: Maybe<NextStandardSurvey>;
  editRewardsPlan: RewardsPlanResponse;
  emailAttendanceReport: EmailAttendanceReportResponse;
  joinMeeting: JoinMeetingResponse;
  markDashboardNotificationsAsSeen: MarkDashboardNotificationsAsSeenMutationResponse;
  markEarnedRewardsAsSeen: MarkEarnedRewardsAsSeenResponse;
  registerDeviceToken?: Maybe<RegisterDeviceTokenResponse>;
  registerLastActive: RegisterLastActiveResponse;
  removeDashboardUserFromChannel: RemoveDashboardUserFromChannelResponse;
  removeDashboardUserFromChannels: RemoveDashboardUserFromChannelsResponse;
  renewMessagingSessionToken: RenewMessagingSessionTokenResponse;
  requestChangePeer: MemberBenefitsMutationResponse;
  requestChangePhoneVerification: RequestVerificationResponse;
  requestDashboardPasswordReset: RequestDashboardPasswordResetResponse;
  requestOnboardingPhoneVerification: RequestVerificationResponse;
  requestSigninVerificationCode: RequestVerificationResponse;
  resetPasswordForDashboardUser: ResetPasswordMutationResponse;
  retireFeature: Feature;
  rewardCredentials: RewardCredentialsResponse;
  rolloutFeature: Feature;
  saveQuote: InspirationalQuoteMutationResponse;
  sendMessageToMembers: SendMessageToMembersResponse;
  setAccountStatusV2: SetAccountStatusMutationResponse;
  setRewardsEnabled: SetRewardsEnabledResponse;
  setRoutineStatus: SetRoutineStatusResponse;
  signInDashboardUserV2: SignInDashboardUserResponseV2;
  signInV2: SignInResponseV2;
  signOut: SignOutResponse;
  unSaveQuote: InspirationalQuoteMutationResponse;
  unassignPeer: MemberBenefitsMutationResponse;
  updateAvailabilityHours: UpdateDashboardUserResponse;
  updateBrandKeys: ContractMutationResponse;
  updateContactPermissions: MemberMutationResponse;
  updateContract: ContractMutationResponse;
  updateContractNotes: ContractMutationResponse;
  updateDashboardUser: UpdateDashboardUserResponse;
  updateEligibilityInfo: MemberMutationResponse;
  updateEngagement: EngagementMutationResponse;
  updateFeatureOverrides?: Maybe<UpdateFeatureOverridesResponse>;
  updateGratitudeList: GratitudeListMutationResponse;
  updateIntake: MemberMutationResponse;
  updateMemberTreatmentProvider?: Maybe<Member>;
  updateMemberV3: Member;
  updateMembersBenefits: Array<Member>;
  updateNotes: MemberMutationResponse;
  updateOutreach: OutreachMutationResponse;
  updatePeerStateCertifications: UpdateDashboardUserResponse;
  updatePhoneNumber: UpdatePhoneNumberResponse;
  /** @deprecated complete profile removed */
  updateProblematicSubstancesV2: MemberMutationResponse;
  updateReleaseOfInformation: ReleaseOfInformationMutationResponse;
  updateRewardsCode: RewardsCodeMutationResponse;
  updateRewardsCodes: RewardsCodesMutationResponse;
  updateRoutineV3: UpdateRoutineMutationResponse;
  updateStarred: MemberMutationResponse;
  updateStrengths: MemberMutationResponse;
  updateSubscriptionPaymentMethod: SubscriptionMutationResponse;
  updateSubscriptionPrice: SubscriptionMutationResponse;
  updateTimeTravelV3: UpdateTimeTravelResponse;
  updateTreatmentProvider: TreatmentProviderMutationResponse;
  updateVacationMessage: UpdateDashboardUserResponse;
  updateWellnessGoal: WellnessGoalMutationResponse;
  upgradeAccountV3: UpgradeAccountMutationResponse;
  upgradeByAdmin: MemberMutationResponse;
  upsertFeatureOverride: Override;
  validateOnboardingCodeV2: ValidateOnboardingCodeMutationResponse;
  validatePromoCode: PromoCodeMutationResponse;
  verifyChangePhoneV2: VerifyChangeCredentialMutationResponse;
};


export type MutationAddDashboardUserToChannelArgs = {
  url: Scalars['String']['input'];
};


export type MutationAnswerBarc10V3Args = {
  input: Barc10V3Input;
};


export type MutationAnswerPeerSupportQuestionnaireArgs = {
  input: PeerSupportQuestionnaireInput;
};


export type MutationAnswerStandardSurveyArgs = {
  input: StandardSurveyInput;
};


export type MutationAssignPeerArgs = {
  input: AssignPeerInput;
};


export type MutationAuthorizeGoogleArgs = {
  input: AuthorizeGoogleInput;
};


export type MutationAuthorizeZoomArgs = {
  input: AuthorizeZoomInput;
};


export type MutationBeginCheckoutArgs = {
  input: BeginCheckoutInput;
};


export type MutationCancelCheckoutArgs = {
  setupIntentId: Scalars['String']['input'];
};


export type MutationChangeDashboardUserPasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCreateAccountV5Args = {
  input?: InputMaybe<CreateAccountV5Input>;
};


export type MutationCreateBulkRoutineV2Args = {
  input: CreateBulkRoutineV2Input;
};


export type MutationCreateCheckinV3Args = {
  input: CreateCheckinInput;
};


export type MutationCreateContractV2Args = {
  input: ContractInput;
};


export type MutationCreateDashboardUserArgs = {
  input: CreateDashboardUserInput;
};


export type MutationCreateEngagementArgs = {
  input: EngagementInput;
};


export type MutationCreateFeatureArgs = {
  input: CreateFeatureInput;
};


export type MutationCreateGratitudeListArgs = {
  input: GratitudeListInput;
};


export type MutationCreateOutreachArgs = {
  input: OutreachInput;
};


export type MutationCreateRedeemedRewardV2Args = {
  input: CreateRedeemedRewardInput;
};


export type MutationCreateReleaseOfInformationArgs = {
  input: ReleaseOfInformationInput;
  memberId: Scalars['Int']['input'];
};


export type MutationCreateRewardsCodeArgs = {
  input: CreateRewardsCodeInput;
};


export type MutationCreateRewardsCodesArgs = {
  input: CreateRewardsCodesInput;
};


export type MutationCreateRewardsPlanArgs = {
  input: CreateRewardsPlanInput;
};


export type MutationCreateRoutineV2Args = {
  input: CreateRoutineV2Input;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateTreatmentProviderArgs = {
  input: CreateTreatmentProviderInput;
};


export type MutationCreateWellnessGoalArgs = {
  input: WellnessGoalInput;
  memberId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteCheckinArgs = {
  input: DeleteCheckinInput;
};


export type MutationDeleteDeviceArgs = {
  input: DeleteDeviceInput;
};


export type MutationDeleteEngagementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGratitudeListArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMemberBenefitsArgs = {
  input: DeleteMemberBenefitsInput;
};


export type MutationDeleteOutreachArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRecurrenceArgs = {
  input: DeleteRecurrenceInputV2;
};


export type MutationDeleteReleaseOfInformationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRewardsCodesArgs = {
  input: DeleteRewardsCodesInput;
};


export type MutationDeleteRoutineV2Args = {
  input: DeleteRoutineV2Input;
};


export type MutationDeleteTreatmentProviderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteWellnessGoalArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDestroyFeatureArgs = {
  input: DestroyFeatureInput;
};


export type MutationEditRewardsPlanArgs = {
  input: EditRewardsPlanInput;
};


export type MutationEmailAttendanceReportArgs = {
  input: EmailAttendanceReportInput;
};


export type MutationJoinMeetingArgs = {
  input: JoinMeetingInput;
};


export type MutationMarkDashboardNotificationsAsSeenArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationRegisterLastActiveArgs = {
  input?: InputMaybe<RegisterLastActiveInput>;
};


export type MutationRemoveDashboardUserFromChannelArgs = {
  url: Scalars['String']['input'];
};


export type MutationRemoveDashboardUserFromChannelsArgs = {
  urls: Array<Scalars['String']['input']>;
};


export type MutationRequestChangePeerArgs = {
  input: PeerChangeRequestInput;
};


export type MutationRequestChangePhoneVerificationArgs = {
  input: RequestPhoneVerificationInput;
};


export type MutationRequestDashboardPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestOnboardingPhoneVerificationArgs = {
  input: RequestPhoneVerificationInput;
};


export type MutationRequestSigninVerificationCodeArgs = {
  input: RequestSmsVerificationCodeInput;
};


export type MutationResetPasswordForDashboardUserArgs = {
  input: ResetPasswordInput;
};


export type MutationRetireFeatureArgs = {
  input: FeatureRetireInput;
};


export type MutationRewardCredentialsArgs = {
  input: RewardCredentialsInput;
};


export type MutationRolloutFeatureArgs = {
  input: FeatureRolloutInput;
};


export type MutationSaveQuoteArgs = {
  quoteId: Scalars['Int']['input'];
};


export type MutationSendMessageToMembersArgs = {
  input: SendMessageToMembersInput;
};


export type MutationSetAccountStatusV2Args = {
  input: SetAccountStatusInput;
};


export type MutationSetRewardsEnabledArgs = {
  input: SetRewardsEnabledInput;
};


export type MutationSetRoutineStatusArgs = {
  input: SetRoutineStatusInput;
};


export type MutationSignInDashboardUserV2Args = {
  input: SignInDashboardUserInput;
};


export type MutationSignInV2Args = {
  input: SignInWithPhoneNumberInput;
};


export type MutationSignOutArgs = {
  input: SignOutInput;
};


export type MutationUnSaveQuoteArgs = {
  quoteId: Scalars['Int']['input'];
};


export type MutationUnassignPeerArgs = {
  memberId: Scalars['Int']['input'];
};


export type MutationUpdateAvailabilityHoursArgs = {
  input: AvailabilityHoursInput;
  peerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateBrandKeysArgs = {
  input: UpdateBrandKeysInput;
};


export type MutationUpdateContactPermissionsArgs = {
  input: Array<MemberContactPermissionsInput>;
};


export type MutationUpdateContractArgs = {
  id: Scalars['Int']['input'];
  input: ContractInput;
};


export type MutationUpdateContractNotesArgs = {
  id: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDashboardUserArgs = {
  input: UpdateDashboardUserInput;
};


export type MutationUpdateEligibilityInfoArgs = {
  input: UpdateEligibilityInput;
};


export type MutationUpdateEngagementArgs = {
  id: Scalars['Int']['input'];
  input: EngagementInput;
};


export type MutationUpdateFeatureOverridesArgs = {
  input: UpdateFeatureOverridesInput;
};


export type MutationUpdateGratitudeListArgs = {
  id: Scalars['Int']['input'];
  input: GratitudeListInput;
};


export type MutationUpdateIntakeArgs = {
  input: IntakeInput;
  memberId: Scalars['Int']['input'];
};


export type MutationUpdateMemberTreatmentProviderArgs = {
  input: UpdateMemberTreatmentProviderInput;
};


export type MutationUpdateMemberV3Args = {
  input: UpdateMemberV3Input;
};


export type MutationUpdateMembersBenefitsArgs = {
  input: UpdateMembersBenefitsInput;
};


export type MutationUpdateNotesArgs = {
  input: UpdateNotesInput;
};


export type MutationUpdateOutreachArgs = {
  id: Scalars['Int']['input'];
  input: OutreachInput;
};


export type MutationUpdatePeerStateCertificationsArgs = {
  input: Array<PeerStateCertificationInput>;
  peerId: Scalars['Int']['input'];
};


export type MutationUpdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};


export type MutationUpdateProblematicSubstancesV2Args = {
  input: UpdateProblematicSubstancesV2Input;
};


export type MutationUpdateReleaseOfInformationArgs = {
  id: Scalars['Int']['input'];
  input: ReleaseOfInformationInput;
};


export type MutationUpdateRewardsCodeArgs = {
  input: UpdateRewardsCodeInput;
};


export type MutationUpdateRewardsCodesArgs = {
  input: UpdateRewardsCodesInput;
};


export type MutationUpdateRoutineV3Args = {
  input: UpdateRoutineV3Input;
};


export type MutationUpdateStarredArgs = {
  input: UpdateStarredInput;
};


export type MutationUpdateStrengthsArgs = {
  input: StrengthInput;
  memberId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateSubscriptionPaymentMethodArgs = {
  setupIntentId: Scalars['String']['input'];
};


export type MutationUpdateSubscriptionPriceArgs = {
  input: UpdateSubscriptionPriceInput;
};


export type MutationUpdateTimeTravelV3Args = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateTreatmentProviderArgs = {
  input: UpdateTreatmentProviderInput;
};


export type MutationUpdateVacationMessageArgs = {
  input: VacationMessageInput;
  peerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateWellnessGoalArgs = {
  id: Scalars['Int']['input'];
  input: WellnessGoalInput;
};


export type MutationUpgradeAccountV3Args = {
  input: UpgradeAccountInput;
};


export type MutationUpgradeByAdminArgs = {
  input: UpgradeByAdminInput;
};


export type MutationUpsertFeatureOverrideArgs = {
  input: UpsertFeatureOverrideInput;
};


export type MutationValidateOnboardingCodeV2Args = {
  input: ValidateOnboardingCodeInput;
};


export type MutationValidatePromoCodeArgs = {
  input: ValidatePromoCodeInput;
};


export type MutationVerifyChangePhoneV2Args = {
  input: VerifyChangeCredentialInput;
};

export type MutationResponse = {
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type NextStandardSurvey = {
  __typename?: 'NextStandardSurvey';
  expiresAt: Scalars['DateTime']['output'];
  rewardAmount: Scalars['Int']['output'];
  shouldShow: Scalars['Boolean']['output'];
  shouldShowCard: Scalars['Boolean']['output'];
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc'
}

export type Outreach = {
  __typename?: 'Outreach';
  id: Scalars['Int']['output'];
  member: Member;
  notes?: Maybe<Scalars['String']['output']>;
  peer: DashboardUser;
  startedAt: Scalars['DateTime']['output'];
  type: OutreachType;
};

export type OutreachInput = {
  memberId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startedAt: Scalars['DateTime']['input'];
  type: OutreachType;
};

export type OutreachMutationResponse = MutationResponse & {
  __typename?: 'OutreachMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  outreach?: Maybe<OutreachResponse>;
  success: Scalars['Boolean']['output'];
};

export type OutreachResponse = Outreach | ValidationErrors;

export enum OutreachType {
  PhoneCall = 'PhoneCall',
  TextMessage = 'TextMessage',
  Voicemail = 'Voicemail'
}

export type Override = {
  __typename?: 'Override';
  key: Scalars['String']['output'];
  memberId: Scalars['Int']['output'];
  value: Scalars['Boolean']['output'];
};

export type PaidSubscription = {
  __typename?: 'PaidSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  gracePeriodEnd: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  price?: Maybe<Price>;
  startDate: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
};

export type PeerChangeRequest = {
  __typename?: 'PeerChangeRequest';
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  peer?: Maybe<DashboardUser>;
};

export type PeerChangeRequestInput = {
  details?: InputMaybe<Scalars['String']['input']>;
};

export type PeerStateCertification = {
  __typename?: 'PeerStateCertification';
  insuranceState: InsuranceState;
};

export type PeerStateCertificationInput = {
  insuranceStateId: Scalars['Int']['input'];
};

export type PeerSupportArea = {
  __typename?: 'PeerSupportArea';
  group: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PeerSupportQuestionnaire = {
  __typename?: 'PeerSupportQuestionnaire';
  considerations?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  otherConcerns?: Maybe<Scalars['String']['output']>;
  peerSupportAreas?: Maybe<Array<PeerSupportArea>>;
  priorTreatment?: Maybe<PriorTreatmentResponse>;
  socialSupportSystem?: Maybe<SocialSupportSystemResponse>;
};

export type PeerSupportQuestionnaireInput = {
  considerations?: InputMaybe<Scalars['String']['input']>;
  otherConcerns?: InputMaybe<Scalars['String']['input']>;
  peerSupportAreaIds: Array<Scalars['Int']['input']>;
  priorTreatment?: InputMaybe<PriorTreatmentResponse>;
  pronouns?: InputMaybe<Array<MemberPronounInput>>;
  socialSupportSystem?: InputMaybe<SocialSupportSystemResponse>;
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productKey: Scalars['String']['output'];
  recurringInterval: Scalars['String']['output'];
  recurringIntervalCount?: Maybe<Scalars['Int']['output']>;
};

export enum PriorTreatmentResponse {
  No = 'No',
  PreferNotToAnswer = 'PreferNotToAnswer',
  Yes = 'Yes'
}

export type ProblematicSubstance = {
  __typename?: 'ProblematicSubstance';
  freeFormResponse?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PromoCode = {
  __typename?: 'PromoCode';
  amountOff?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Float']['output']>;
};

export type PromoCodeMutationResponse = MutationResponse & {
  __typename?: 'PromoCodeMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  promoCode?: Maybe<PromoCode>;
  success: Scalars['Boolean']['output'];
};

export type Pronoun = {
  __typename?: 'Pronoun';
  customResponse?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type PublicMeeting = {
  __typename?: 'PublicMeeting';
  category: Category;
  duration: Scalars['Int']['output'];
  header: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nextStartsAt?: Maybe<Scalars['DateTime']['output']>;
  recurrence: Array<Scalars['String']['output']>;
  routine?: Maybe<Routine>;
  timeZone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum PublicMeetingType {
  General = 'General',
  Specialized = 'Specialized'
}

export type PublicOnlineMeetingV3 = {
  __typename?: 'PublicOnlineMeetingV3';
  category: Category;
  duration: Scalars['Int']['output'];
  header: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  routine?: Maybe<Routine>;
  startTime: Scalars['DateTime']['output'];
  timeZone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  appVersion: AppVersion;
  barc10Questions: Array<Barc10Question>;
  categories: Array<Category>;
  challengeStructures: Array<ChallengeStructure>;
  contactPermissions: Array<ContactPermission>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  currentAppVersion: Scalars['String']['output'];
  dashboardNotifications: QueryDashboardNotificationsResponse;
  dashboardUser: DashboardUser;
  dashboardUsers: Array<DashboardUser>;
  deletedMessages: Array<DeletedMessage>;
  featureOverrides?: Maybe<Array<FeatureOverride>>;
  features: Array<Feature>;
  findMember?: Maybe<Member>;
  getBarc10Surveys: Array<Barc10Survey>;
  giftCardBrands: Array<Brand>;
  groups: Array<RoutineCategoryGroup>;
  healthPlans: Array<HealthPlan>;
  insuranceStates: Array<InsuranceState>;
  lossOfEligibilityReport: Array<Member>;
  memberRewardsStatusAudits: Array<Audit>;
  memberV2: Member;
  multiuseRewardsCodes: RewardsCodesResponse;
  peer?: Maybe<DashboardUser>;
  peerStats: Array<DashboardUser>;
  peerSupportAreas: Array<PeerSupportArea>;
  peerSupportAreasV2: Array<PeerSupportArea>;
  peers: Array<DashboardUser>;
  prices: Array<Price>;
  /** @deprecated complete profile removed */
  problematicSubstances: Array<ProblematicSubstance>;
  pronouns: Array<Pronoun>;
  publicMeeting?: Maybe<PublicMeeting>;
  publicMeetings: Array<PublicMeeting>;
  /** @deprecated use publicMeeting */
  publicOnlineMeeting?: Maybe<PublicOnlineMeetingV3>;
  queryChallenges: QueryChallengesResponse;
  queryEngagementsV2: QueryEngagementsResponse;
  queryMembers: QueryMembersResponse;
  queryOutreaches: QueryOutreachesResponse;
  queryRedeemedRewards: QueryRedeemedRewardsResponse;
  queryStandardSurveys: QueryStandardSurveysResponse;
  queryWellnessGoals: Array<WellnessGoal>;
  randomQuote: InspirationalQuote;
  rewardsCatalog: Array<Brand>;
  rewardsCode?: Maybe<RewardsCode>;
  rewardsCodes: RewardsCodesResponse;
  rewardsPlans: Array<RewardsPlan>;
  routine: Routine;
  routineRecurrenceV2?: Maybe<RecurrenceV3>;
  smartRoutine?: Maybe<SmartRoutine>;
  supportedHealthPlans: Array<SupportedHealthPlan>;
  treatmentProviders: Array<TreatmentProvider>;
  validateActivationCode: ValidateActivationCodeResponse;
  wellnessGoal?: Maybe<WellnessGoal>;
};


export type QueryCategoriesArgs = {
  group: CategoryGroup;
};


export type QueryContractArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDashboardNotificationsArgs = {
  input?: InputMaybe<QueryDashboardNotificationsInput>;
};


export type QueryFeatureOverridesArgs = {
  key: Scalars['String']['input'];
};


export type QueryFindMemberArgs = {
  memberId: Scalars['Int']['input'];
};


export type QueryGetBarc10SurveysArgs = {
  memberId: Scalars['Int']['input'];
};


export type QueryGroupsArgs = {
  type?: InputMaybe<RoutineType>;
};


export type QueryMemberRewardsStatusAuditsArgs = {
  memberId: Scalars['Int']['input'];
};


export type QueryMultiuseRewardsCodesArgs = {
  input: RewardsCodesInput;
};


export type QueryPeerArgs = {
  peerId: Scalars['Int']['input'];
};


export type QueryPeerSupportAreasV2Args = {
  version: Scalars['Int']['input'];
};


export type QueryPublicMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPublicMeetingsArgs = {
  type: PublicMeetingType;
};


export type QueryPublicOnlineMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQueryChallengesArgs = {
  input: QueryChallengesInput;
};


export type QueryQueryEngagementsV2Args = {
  input: QueryEngagementsInput;
};


export type QueryQueryMembersArgs = {
  input: QueryMembersInput;
};


export type QueryQueryOutreachesArgs = {
  input: QueryOutreachesInput;
};


export type QueryQueryRedeemedRewardsArgs = {
  input: QueryRedeemedRewardsInput;
};


export type QueryQueryStandardSurveysArgs = {
  input: QueryStandardSurveysInput;
};


export type QueryQueryWellnessGoalsArgs = {
  input: QueryWellnessGoalsInput;
};


export type QueryRewardsCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRewardsCodesArgs = {
  input: RewardsCodesInput;
};


export type QueryRoutineArgs = {
  input: RoutineQueryInput;
};


export type QueryRoutineRecurrenceV2Args = {
  id: Scalars['Int']['input'];
  startsAt: Scalars['DateTime']['input'];
};


export type QuerySmartRoutineArgs = {
  input: SmartRoutineQueryInput;
};


export type QueryValidateActivationCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryWellnessGoalArgs = {
  id: Scalars['Int']['input'];
};

export type QueryByField = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type QueryChallengesInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryChallengesResponse = QueryResponse & {
  __typename?: 'QueryChallengesResponse';
  challenges: Array<Challenge>;
  cursor?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type QueryDashboardNotificationsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryDashboardNotificationsResponse = QueryResponse & {
  __typename?: 'QueryDashboardNotificationsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  notifications: Array<DashboardNotification>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalUnseenCount: Scalars['Int']['output'];
};

export type QueryEngagementsInput = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  peerId?: InputMaybe<Scalars['Int']['input']>;
  successful?: InputMaybe<Scalars['Boolean']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<EngagementType>;
};

export type QueryEngagementsResponse = QueryResponse & {
  __typename?: 'QueryEngagementsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  engagements: Array<Engagement>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalMinutes: Scalars['Int']['output'];
  uniqueMemberCount: Scalars['Int']['output'];
};

export type QueryMembersInput = {
  benefits?: InputMaybe<MemberBenefitsFilters>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  engaged?: InputMaybe<Scalars['Boolean']['input']>;
  messagingBenefitStatus?: InputMaybe<MessagingBenefitStatus>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<QueryMembersOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryByFields?: InputMaybe<QueryByField>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  treatmentProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export enum QueryMembersOrderBy {
  AccountDeactivationDate = 'AccountDeactivationDate',
  BenefitsActivatedAt = 'BenefitsActivatedAt',
  ContractName = 'ContractName',
  CreatedAt = 'CreatedAt',
  EarnedRewards = 'EarnedRewards',
  Id = 'ID',
  Language = 'Language',
  LastMessageRead = 'LastMessageRead',
  LastMessageSent = 'LastMessageSent',
  LastMessageSentBy = 'LastMessageSentBy',
  LastOutreach = 'LastOutreach',
  MaxPotentialRewards = 'MaxPotentialRewards',
  MessageCount = 'MessageCount',
  MessagingEndsAt = 'MessagingEndsAt',
  Name = 'Name',
  OutreachCount = 'OutreachCount',
  ProgressDate = 'ProgressDate',
  RewardsEndsAt = 'RewardsEndsAt',
  TreatmentProviderName = 'TreatmentProviderName'
}

export type QueryMembersResponse = QueryResponse & {
  __typename?: 'QueryMembersResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  membersV2: Array<Member>;
  order: Order;
  orderBy: QueryMembersOrderBy;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type QueryOutreachesInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  peerId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryOutreachesResponse = QueryResponse & {
  __typename?: 'QueryOutreachesResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  outreaches: Array<Outreach>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type QueryParams = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRedeemedRewardsInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRedeemedRewardsResponse = QueryResponse & {
  __typename?: 'QueryRedeemedRewardsResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  rewards: Array<RedeemedReward>;
  totalCount: Scalars['Int']['output'];
};

export type QueryResponse = {
  cursor?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type QueryStandardSurveysInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryStandardSurveysResponse = QueryResponse & {
  __typename?: 'QueryStandardSurveysResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  surveys: Array<StandardSurveyV2>;
  totalCount: Scalars['Int']['output'];
};

export type QueryWellnessGoalsInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
};

export enum RoiStatus {
  Sent = 'Sent',
  Signed = 'Signed'
}

export type RecurrenceV3 = {
  __typename?: 'RecurrenceV3';
  anytime: Scalars['Boolean']['output'];
  category?: Maybe<Category>;
  checkin?: Maybe<Checkin>;
  creationInfo?: Maybe<RoutineCreationInfo>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isFloating: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  origin: RoutineOrigin;
  originalStartsAt?: Maybe<Scalars['DateTime']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  publicMeeting?: Maybe<PublicOnlineMeetingV3>;
  recurrence: Array<Scalars['String']['output']>;
  reminders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  startsAt: Scalars['DateTime']['output'];
  status: RoutineStatusType;
  statusChanged?: Maybe<Scalars['DateTime']['output']>;
  type: RoutineType;
  uuid: Scalars['String']['output'];
  wellnessGoals: Array<WellnessGoal>;
};


export type RecurrenceV3CheckinArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedeemedReward = {
  __typename?: 'RedeemedReward';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isRedeemed?: Maybe<Scalars['Boolean']['output']>;
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
  referenceOrderId?: Maybe<Scalars['String']['output']>;
  test: Scalars['Boolean']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
};

export type RegisterDeviceTokenInput = {
  deviceId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RegisterDeviceTokenResponse = {
  __typename?: 'RegisterDeviceTokenResponse';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type RegisterLastActiveInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegisterLastActiveResponse = {
  __typename?: 'RegisterLastActiveResponse';
  activeStreaks: ActiveStreaks;
};

export type ReleaseOfInformation = {
  __typename?: 'ReleaseOfInformation';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  status: RoiStatus;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ReleaseOfInformationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  status: RoiStatus;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ReleaseOfInformationMutationResponse = MutationResponse & {
  __typename?: 'ReleaseOfInformationMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  releaseOfInformation?: Maybe<ReleaseOfInformationResponse>;
  success: Scalars['Boolean']['output'];
};

export type ReleaseOfInformationResponse = ReleaseOfInformation | ValidationErrors;

export type RemoveDashboardUserFromChannelResponse = MutationResponse & {
  __typename?: 'RemoveDashboardUserFromChannelResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveDashboardUserFromChannelsResponse = MutationResponse & {
  __typename?: 'RemoveDashboardUserFromChannelsResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RenewMessagingSessionTokenResponse = {
  __typename?: 'RenewMessagingSessionTokenResponse';
  sessionToken?: Maybe<SessionToken>;
};

export type RequestDashboardPasswordResetResponse = MutationResponse & {
  __typename?: 'RequestDashboardPasswordResetResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestPhoneVerificationInput = {
  phoneNumber: Scalars['String']['input'];
};

export type RequestSmsVerificationCodeInput = {
  phoneNumber: Scalars['String']['input'];
};

export type RequestVerificationResponse = {
  __typename?: 'RequestVerificationResponse';
  sendTime: Scalars['DateTime']['output'];
  to: Scalars['String']['output'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
};

export type ResetPasswordMutationResponse = MutationResponse & {
  __typename?: 'ResetPasswordMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  session?: Maybe<SessionResponse>;
  success: Scalars['Boolean']['output'];
};

export type RewardCredentialsInput = {
  rewardId: Scalars['Int']['input'];
};

export type RewardCredentialsResponse = {
  __typename?: 'RewardCredentialsResponse';
  claimCode?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  redemptionInstructions?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RewardsCode = {
  __typename?: 'RewardsCode';
  code: Scalars['String']['output'];
  contract: Contract;
  createdAt: Scalars['DateTime']['output'];
  distributionMethod?: Maybe<DistributionMethod>;
  id: Scalars['Int']['output'];
  redemptionLimit: Scalars['Int']['output'];
  redemptionsRemaining: Scalars['Int']['output'];
  startingBalance?: Maybe<Scalars['Int']['output']>;
  treatmentProvider?: Maybe<TreatmentProvider>;
};

export type RewardsCodeMutationResponse = MutationResponse & {
  __typename?: 'RewardsCodeMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  rewardsCode?: Maybe<RewardsCodeResponse>;
  success: Scalars['Boolean']['output'];
};

export type RewardsCodeResponse = RewardsCode | ValidationErrors;

export type RewardsCodesInput = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
  distributionMethod?: InputMaybe<DistributionMethod>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<RewardsCodesOrderBy>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  treatmentProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export type RewardsCodesMutationResponse = MutationResponse & {
  __typename?: 'RewardsCodesMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  rewardsCodes?: Maybe<Array<RewardsCodeResponse>>;
  success: Scalars['Boolean']['output'];
};

export enum RewardsCodesOrderBy {
  Code = 'Code',
  ContractName = 'ContractName',
  CreatedAt = 'CreatedAt',
  DistributionMethod = 'DistributionMethod',
  TreatmentProviderName = 'TreatmentProviderName'
}

export type RewardsCodesResponse = QueryResponse & {
  __typename?: 'RewardsCodesResponse';
  cursor?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderBy: RewardsCodesOrderBy;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize: Scalars['Int']['output'];
  rewardsCodes: Array<RewardsCode>;
  totalCount: Scalars['Int']['output'];
};

export type RewardsPlan = {
  __typename?: 'RewardsPlan';
  activeMembers?: Maybe<Scalars['Int']['output']>;
  barc10Amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  segments: Array<RewardsPlanSegment>;
  surveyAmount: Scalars['Int']['output'];
};

export type RewardsPlanMutationResponse = RewardsPlan | ValidationErrors;

export type RewardsPlanResponse = MutationResponse & {
  __typename?: 'RewardsPlanResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  rewardsPlan?: Maybe<RewardsPlanMutationResponse>;
  success: Scalars['Boolean']['output'];
};

export type RewardsPlanSegment = {
  __typename?: 'RewardsPlanSegment';
  challengeStructure: ChallengeStructure;
  id: Scalars['Int']['output'];
  thresholdAmount: Scalars['Int']['output'];
};

export type RewardsPlanSegmentInput = {
  challengeStructureId: Scalars['Int']['input'];
  thresholdAmount: Scalars['Int']['input'];
};

export enum Role {
  Admin = 'Admin',
  MemberEngagementSpecialist = 'MemberEngagementSpecialist',
  Peer = 'Peer',
  PeerSupervisor = 'PeerSupervisor'
}

export enum RolloutPhase {
  Dev = 'Dev',
  Initial = 'Initial',
  Off = 'Off',
  On = 'On'
}

export type Routine = {
  __typename?: 'Routine';
  anytime: Scalars['Boolean']['output'];
  category?: Maybe<Category>;
  closestStartsAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  creationInfo?: Maybe<RoutineCreationInfo>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  duration: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isChild?: Maybe<Scalars['Boolean']['output']>;
  lastCheckin?: Maybe<Checkin>;
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  origin: RoutineOrigin;
  publicMeeting?: Maybe<PublicMeeting>;
  recurrence: Array<Scalars['String']['output']>;
  recurrencesV2?: Maybe<Array<RecurrenceV3>>;
  reminders?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  status: RoutineStatusType;
  statusChanged?: Maybe<Scalars['DateTime']['output']>;
  type: RoutineType;
  wellnessGoals: Array<WellnessGoal>;
};


export type RoutineClosestStartsAtArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone: Scalars['String']['input'];
};


export type RoutineRecurrencesV2Args = {
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type RoutineCategoryGroup = {
  __typename?: 'RoutineCategoryGroup';
  categories: Array<Category>;
  id: Scalars['Int']['output'];
  name: CategoryGroup;
  position?: Maybe<Scalars['Int']['output']>;
  requirement: RoutineCreationRequirement;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RoutineCreationInfo = {
  __typename?: 'RoutineCreationInfo';
  createdBy: Scalars['String']['output'];
};

export enum RoutineCreationRequirement {
  /** @deprecated No longer supported */
  Location = 'Location',
  LocationOrUserLink = 'LocationOrUserLink',
  None = 'None',
  ProviderLink = 'ProviderLink'
}

export type RoutineLocationInput = {
  formattedAddress: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
};

export enum RoutineOrigin {
  DefaultDay = 'DefaultDay',
  Routinify = 'Routinify',
  Self = 'Self',
  TreatmentCenter = 'TreatmentCenter'
}

export type RoutineQueryInput = {
  memberId?: InputMaybe<Scalars['Int']['input']>;
  routineId: Scalars['Int']['input'];
};

export type RoutineResponse = Routine | ValidationErrors;

export enum RoutineStatusType {
  Accepted = 'Accepted',
  Mandatory = 'Mandatory',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export enum RoutineType {
  SelfCare = 'SelfCare',
  Support = 'Support'
}

export type RoutinesInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export enum SudConcernsInput {
  No = 'No',
  PreferNotToAnswer = 'PreferNotToAnswer',
  Yes = 'Yes'
}

export type SendMessageToMembersInput = {
  memberIds: Array<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
};

export type SendMessageToMembersResponse = MutationResponse & {
  __typename?: 'SendMessageToMembersResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Session = {
  __typename?: 'Session';
  jwt: Scalars['ID']['output'];
  sendbirdToken?: Maybe<SessionToken>;
};

export type SessionResponse = Session | ValidationErrors;

export type SessionToken = {
  __typename?: 'SessionToken';
  expiresAt: Scalars['Float']['output'];
  token: Scalars['String']['output'];
};

export type SetAccountStatusInput = {
  accountStatus: AccountStatus;
  memberId: Scalars['Int']['input'];
};

export type SetAccountStatusMutationResponse = MutationResponse & {
  __typename?: 'SetAccountStatusMutationResponse';
  code: Scalars['Int']['output'];
  member?: Maybe<Member>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SetRewardsEnabledInput = {
  id: Scalars['Int']['input'];
  rewardsEnabled: Scalars['Boolean']['input'];
};

export type SetRewardsEnabledResponse = {
  __typename?: 'SetRewardsEnabledResponse';
  memberV2: Member;
};

export type SetRoutineStatusInput = {
  newStatus: RoutineStatusType;
  routineId: Scalars['Int']['input'];
};

export type SetRoutineStatusResponse = {
  __typename?: 'SetRoutineStatusResponse';
  _?: Maybe<Scalars['Boolean']['output']>;
  routine: Routine;
};

export type SignInDashboardUserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignInDashboardUserResponse = {
  __typename?: 'SignInDashboardUserResponse';
  session: Session;
};

export type SignInDashboardUserResponseV2 = MutationResponse & {
  __typename?: 'SignInDashboardUserResponseV2';
  code: Scalars['Int']['output'];
  dashboardUser?: Maybe<DashboardUser>;
  message: Scalars['String']['output'];
  session?: Maybe<Session>;
  success: Scalars['Boolean']['output'];
};

export type SignInResponseV2 = MutationResponse & {
  __typename?: 'SignInResponseV2';
  code: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  success: Scalars['Boolean']['output'];
};

export type SignInWithPhoneNumberInput = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type SignOutInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

export type SignOutResponse = {
  __typename?: 'SignOutResponse';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type SmartRoutine = {
  __typename?: 'SmartRoutine';
  anytime?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Category>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  openaiId: Scalars['String']['output'];
  recurrence: Array<Scalars['String']['output']>;
};

export type SmartRoutineQueryInput = {
  routineDescription: Scalars['String']['input'];
};

export enum SocialSupportSystemResponse {
  No = 'No',
  NotSure = 'NotSure',
  Yes = 'Yes'
}

export type StandardSurveyInput = {
  biggestChallenge?: InputMaybe<Scalars['String']['input']>;
  feedbackHelps?: InputMaybe<Scalars['String']['input']>;
  hasHelpedNPS: Scalars['String']['input'];
  howSpentRewards?: InputMaybe<Array<Scalars['String']['input']>>;
  mostHelpfulForRecovery?: InputMaybe<Scalars['String']['input']>;
  wouldRecommendNPS: Scalars['String']['input'];
};

export type StandardSurveyV2 = {
  __typename?: 'StandardSurveyV2';
  biggestChallenge?: Maybe<Scalars['String']['output']>;
  dateCompleted: Scalars['DateTime']['output'];
  days: Scalars['Int']['output'];
  earnedReward?: Maybe<EarnedReward>;
  feedbackHelps?: Maybe<Scalars['String']['output']>;
  hasHelpedNPS: Scalars['String']['output'];
  howSpentRewards?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Int']['output'];
  /** @deprecated removed from standard survey */
  lastDaysAttendedMeetings?: Maybe<Scalars['Int']['output']>;
  mostHelpfulForRecovery?: Maybe<Scalars['String']['output']>;
  wouldRecommendNPS: Scalars['String']['output'];
};

export type Strength = {
  __typename?: 'Strength';
  id: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  responses: Array<StrengthResponse>;
};

export type StrengthInput = {
  promptId: Scalars['Int']['input'];
  responses: Array<Scalars['String']['input']>;
};

export type StrengthResponse = {
  __typename?: 'StrengthResponse';
  id: Scalars['Int']['output'];
  response: Scalars['String']['output'];
};

export type SubscriptionMutationResponse = MutationResponse & {
  __typename?: 'SubscriptionMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<PaidSubscription>;
  success: Scalars['Boolean']['output'];
};

export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type SupportedHealthPlan = {
  __typename?: 'SupportedHealthPlan';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SupportivePerson = {
  __typename?: 'SupportivePerson';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  relationship?: Maybe<Scalars['String']['output']>;
};

export type SupportivePersonInput = {
  name: Scalars['String']['input'];
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type TimeTravelInput = {
  timeTravel?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TreatmentProvider = {
  __typename?: 'TreatmentProvider';
  contract: Contract;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TreatmentProviderMutationResponse = MutationResponse & {
  __typename?: 'TreatmentProviderMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  treatmentProvider?: Maybe<TreatmentProvider>;
};

export type UpdateBrandKeysInput = {
  id: Scalars['Int']['input'];
  tangoBrandKeys: Array<Scalars['String']['input']>;
};

export type UpdateDashboardUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bioSpanish?: InputMaybe<Scalars['String']['input']>;
  calendarLink?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDashboardUserResponse = MutationResponse & {
  __typename?: 'UpdateDashboardUserResponse';
  code: Scalars['Int']['output'];
  dashboardUser?: Maybe<DashboardUserResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateEligibilityInput = {
  birthDate: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  healthPlanId?: InputMaybe<Scalars['Int']['input']>;
  insuranceMemberId?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  memberId: Scalars['Int']['input'];
};

export type UpdateEngagedResponse = {
  __typename?: 'UpdateEngagedResponse';
  member: Member;
};

export type UpdateFeatureOverridesInput = {
  key: Scalars['String']['input'];
  memberIds: Array<Scalars['Int']['input']>;
};

export type UpdateFeatureOverridesResponse = {
  __typename?: 'UpdateFeatureOverridesResponse';
  key: Scalars['String']['output'];
  memberIds: Array<Scalars['Int']['output']>;
};

export type UpdateMaxPotentialRewardsInput = {
  maxPotentialRewards: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type UpdateMemberTreatmentProviderInput = {
  memberId: Scalars['Int']['input'];
  treatmentProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMemberV3Input = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  languageTag?: InputMaybe<Scalars['String']['input']>;
  lastKnownTimeZone?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  progressDate?: InputMaybe<Scalars['Date']['input']>;
  pronouns?: InputMaybe<Array<MemberPronounInput>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMembersBenefitsInput = {
  memberIds: Array<Scalars['Int']['input']>;
  messagingDaysAdded?: InputMaybe<Scalars['Int']['input']>;
  rewardsAmountAdded?: InputMaybe<Scalars['Int']['input']>;
  rewardsDaysAdded?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNotesInput = {
  csNotes?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['Int']['input'];
  mesNotes?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePhoneNumberInput = {
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type UpdatePhoneNumberResponse = {
  __typename?: 'UpdatePhoneNumberResponse';
  memberV2: Member;
};

export type UpdateProblematicSubstancesV2Input = {
  experiencingSudConcerns: SudConcernsInput;
  problematicSubstances?: InputMaybe<Array<MemberSubstanceInput>>;
};

export type UpdateRewardsCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  redemptionLimit?: InputMaybe<Scalars['Int']['input']>;
  startingBalance?: InputMaybe<Scalars['Int']['input']>;
  treatmentProviderId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRewardsCodesInput = {
  ids: Array<Scalars['Int']['input']>;
  treatmentProvider?: InputMaybe<UpdateRewardsCodesTreatmentProviderInput>;
};

export type UpdateRewardsCodesTreatmentProviderInput = {
  contractId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateRoutineMutationResponse = MutationResponse & {
  __typename?: 'UpdateRoutineMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  routine?: Maybe<RoutineResponse>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRoutineV3Input = {
  anytime: Scalars['Boolean']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  changeFuture: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<RoutineLocationInput>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originalStartsAt: Scalars['DateTime']['input'];
  publicMeetingId?: InputMaybe<Scalars['Int']['input']>;
  recurrence: Array<Scalars['String']['input']>;
  reminders?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  wellnessGoalIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateStarredInput = {
  memberId: Scalars['Int']['input'];
  starred: Scalars['Boolean']['input'];
};

export type UpdateSubscriptionPriceInput = {
  priceId: Scalars['String']['input'];
};

export type UpdateTimeTravelResponse = MutationResponse & {
  __typename?: 'UpdateTimeTravelResponse';
  code: Scalars['Int']['output'];
  member?: Maybe<Member>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateTreatmentProviderInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpgradeAccountInput = {
  birthDate: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  healthPlanId?: InputMaybe<Scalars['Int']['input']>;
  insuranceMemberId?: InputMaybe<Scalars['String']['input']>;
  insuranceProvider?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  preferredName?: InputMaybe<Scalars['String']['input']>;
  rewardsCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  wecWorksConnection?: InputMaybe<WecWorksConnectionType>;
};

export type UpgradeAccountMutationResponse = MutationResponse & {
  __typename?: 'UpgradeAccountMutationResponse';
  code: Scalars['Int']['output'];
  ineligibleReasons?: Maybe<Array<Scalars['String']['output']>>;
  member?: Maybe<MemberResponse>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpgradeByAdminInput = {
  contractId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type UpsertFeatureOverrideInput = {
  key: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type VacationMessage = {
  __typename?: 'VacationMessage';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  textSpanish?: Maybe<Scalars['String']['output']>;
};

export type VacationMessageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  textSpanish?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateActivationCodeResponse = MutationResponse & {
  __typename?: 'ValidateActivationCodeResponse';
  activationCode?: Maybe<RewardsCode>;
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ValidateOnboardingCodeInput = {
  code: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateOnboardingCodeMutationResponse = MutationResponse & {
  __typename?: 'ValidateOnboardingCodeMutationResponse';
  code: Scalars['Int']['output'];
  jwt?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ValidateOnboardingCodeResponse = {
  __typename?: 'ValidateOnboardingCodeResponse';
  jwt: Scalars['String']['output'];
};

export type ValidatePromoCodeInput = {
  promoCode: Scalars['String']['input'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  errors: Array<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

export type ValidationErrors = {
  __typename?: 'ValidationErrors';
  validationErrors: Array<ValidationError>;
};

export enum ValueType {
  FixedValue = 'FIXED_VALUE',
  VariableValue = 'VARIABLE_VALUE'
}

export type VariableItem = Item & {
  __typename?: 'VariableItem';
  maxValue: Scalars['Int']['output'];
  minValue: Scalars['Int']['output'];
  rewardName: Scalars['String']['output'];
  type: ValueType;
  utid: Scalars['String']['output'];
};

export type VerifyChangeCredentialInput = {
  code: Scalars['String']['input'];
};

export type VerifyChangeCredentialMutationResponse = MutationResponse & {
  __typename?: 'VerifyChangeCredentialMutationResponse';
  code: Scalars['Int']['output'];
  member?: Maybe<Member>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type VerifyChangeCredentialResponse = {
  __typename?: 'VerifyChangeCredentialResponse';
  memberV2: Member;
};

export type VerifyEmailInput = {
  code: Scalars['String']['input'];
};

export type VerifyEmailMutationResponse = MutationResponse & {
  __typename?: 'VerifyEmailMutationResponse';
  code: Scalars['Int']['output'];
  member?: Maybe<Member>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum WecWorksConnectionType {
  Dependent = 'Dependent',
  Employee = 'Employee',
  PreferNotToAnswer = 'PreferNotToAnswer',
  Spouse = 'Spouse'
}

export type WellnessGoal = {
  __typename?: 'WellnessGoal';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dashboardUser?: Maybe<DashboardUser>;
  description?: Maybe<Scalars['String']['output']>;
  displayInApp: Scalars['Boolean']['output'];
  domain?: Maybe<WellnessGoalDomain>;
  id: Scalars['Int']['output'];
  member: Member;
  priorityLevel?: Maybe<WellnessGoalPriorityLevel>;
  routines: Array<Routine>;
  status: WellnessGoalStatus;
  title: Scalars['String']['output'];
};

export enum WellnessGoalDomain {
  DailyLivingAndRoutines = 'DailyLivingAndRoutines',
  Education = 'Education',
  Employment = 'Employment',
  Finances = 'Finances',
  Housing = 'Housing',
  Legal = 'Legal',
  MentalHealth = 'MentalHealth',
  Other = 'Other',
  PhysicalHealth = 'PhysicalHealth',
  Relationships = 'Relationships',
  Safety = 'Safety',
  Spirituality = 'Spirituality'
}

export type WellnessGoalInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayInApp?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<WellnessGoalDomain>;
  goal?: InputMaybe<Scalars['String']['input']>;
  priorityLevel?: InputMaybe<WellnessGoalPriorityLevel>;
  status: WellnessGoalStatus;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WellnessGoalMutationResponse = MutationResponse & {
  __typename?: 'WellnessGoalMutationResponse';
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  wellnessGoal?: Maybe<WellnessGoalResponse>;
};

export enum WellnessGoalPriorityLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type WellnessGoalResponse = ValidationErrors | WellnessGoal;

export enum WellnessGoalStatus {
  Complete = 'Complete',
  InProgress = 'InProgress',
  Paused = 'Paused'
}

export type Barc10Answer = {
  __typename?: 'barc10Answer';
  question?: Maybe<Barc10Question>;
  response: Scalars['Int']['output'];
};

export type TestQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TestQueryQuery = { __typename?: 'Query', groups: Array<{ __typename: 'RoutineCategoryGroup' }> };

export type LeaveChannelMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type LeaveChannelMutation = { __typename?: 'Mutation', removeDashboardUserFromChannel: { __typename?: 'RemoveDashboardUserFromChannelResponse', success: boolean, message: string } };

export type MemberConversationInfoQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type MemberConversationInfoQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', id: number, createdAt: DateTime, messagingEnabled: boolean, accountStatus: AccountStatus, benefits?: { __typename?: 'MemberBenefits', id: number, contract?: { __typename?: 'Contract', id: number, name: string } | null } | null, subscription?: { __typename?: 'PaidSubscription', id: string, price?: { __typename?: 'Price', name?: string | null } | null } | null } | null };

export type EngagementFragment = { __typename?: 'Engagement', id: number, successful: boolean, startedAt: DateTime, type: EngagementType, duration: number, notes?: string | null, planChanges?: string | null, goalProgress?: string | null, referrals?: string | null, actions?: string | null } & { ' $fragmentName'?: 'EngagementFragment' };

export type CreateEngagementMutationVariables = Exact<{
  input: EngagementInput;
}>;


export type CreateEngagementMutation = { __typename?: 'Mutation', createEngagement: { __typename?: 'EngagementMutationResponse', success: boolean, message: string, engagement?: (
      { __typename?: 'Engagement', peer: { __typename?: 'DashboardUser', id: number, name: string } }
      & { ' $fragmentRefs'?: { 'EngagementFragment': EngagementFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type UpdateEngagementMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: EngagementInput;
}>;


export type UpdateEngagementMutation = { __typename?: 'Mutation', updateEngagement: { __typename?: 'EngagementMutationResponse', success: boolean, message: string, engagement?: (
      { __typename?: 'Engagement', peer: { __typename?: 'DashboardUser', id: number, name: string } }
      & { ' $fragmentRefs'?: { 'EngagementFragment': EngagementFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type DeleteEngagementMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteEngagementMutation = { __typename?: 'Mutation', deleteEngagement: { __typename?: 'EngagementMutationResponse', success: boolean, message: string, engagement?: { __typename?: 'Engagement', id: number } | { __typename?: 'ValidationErrors' } | null } };

export type NotificationsQueryVariables = Exact<{
  input?: InputMaybe<QueryDashboardNotificationsInput>;
}>;


export type NotificationsQuery = { __typename?: 'Query', dashboardNotifications: { __typename?: 'QueryDashboardNotificationsResponse', totalUnseenCount: number, cursor?: string | null, notifications: Array<(
      { __typename?: 'DashboardNotification' }
      & { ' $fragmentRefs'?: { 'NotificationFragment': NotificationFragment } }
    )> } };

export type MarkNotificationsAsSeenMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type MarkNotificationsAsSeenMutation = { __typename?: 'Mutation', markDashboardNotificationsAsSeen: { __typename?: 'MarkDashboardNotificationsAsSeenMutationResponse', success: boolean, notifications?: Array<{ __typename?: 'DashboardNotification', id: number, seen: boolean }> | null } };

export type NotificationFragment = { __typename?: 'DashboardNotification', event: DashboardNotificationEvent, createdAt: DateTime, id: number, seen: boolean, member: { __typename?: 'Member', id: number, name?: string | null, accountDeactivationDate?: DateTime | null } } & { ' $fragmentName'?: 'NotificationFragment' };

export type OutreachFragment = { __typename?: 'Outreach', id: number, startedAt: DateTime, type: OutreachType, notes?: string | null } & { ' $fragmentName'?: 'OutreachFragment' };

export type CreateOutreachMutationVariables = Exact<{
  input: OutreachInput;
}>;


export type CreateOutreachMutation = { __typename?: 'Mutation', createOutreach: { __typename?: 'OutreachMutationResponse', success: boolean, message: string, outreach?: (
      { __typename?: 'Outreach', peer: { __typename?: 'DashboardUser', id: number, name: string } }
      & { ' $fragmentRefs'?: { 'OutreachFragment': OutreachFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type UpdateOutreachMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: OutreachInput;
}>;


export type UpdateOutreachMutation = { __typename?: 'Mutation', updateOutreach: { __typename?: 'OutreachMutationResponse', success: boolean, message: string, outreach?: (
      { __typename?: 'Outreach', peer: { __typename?: 'DashboardUser', id: number, name: string } }
      & { ' $fragmentRefs'?: { 'OutreachFragment': OutreachFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type DeleteOutreachMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOutreachMutation = { __typename?: 'Mutation', deleteOutreach: { __typename?: 'OutreachMutationResponse', success: boolean, message: string, outreach?: { __typename?: 'Outreach', id: number } | { __typename?: 'ValidationErrors' } | null } };

export type CreateReleaseOfInformationMutationVariables = Exact<{
  memberId: Scalars['Int']['input'];
  input: ReleaseOfInformationInput;
}>;


export type CreateReleaseOfInformationMutation = { __typename?: 'Mutation', createReleaseOfInformation: { __typename?: 'ReleaseOfInformationMutationResponse', success: boolean, message: string } };

export type UpdateReleaseOfInformationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ReleaseOfInformationInput;
}>;


export type UpdateReleaseOfInformationMutation = { __typename?: 'Mutation', updateReleaseOfInformation: { __typename?: 'ReleaseOfInformationMutationResponse', success: boolean, message: string, releaseOfInformation?: (
      { __typename?: 'ReleaseOfInformation' }
      & { ' $fragmentRefs'?: { 'ReleaseOfInformationFragment': ReleaseOfInformationFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type DeleteReleaseOfInformationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteReleaseOfInformationMutation = { __typename?: 'Mutation', deleteReleaseOfInformation: { __typename?: 'ReleaseOfInformationMutationResponse', success: boolean, message: string, releaseOfInformation?: { __typename?: 'ReleaseOfInformation', id: number } | { __typename?: 'ValidationErrors' } | null } };

export type AssignPeerMutationVariables = Exact<{
  input: AssignPeerInput;
}>;


export type AssignPeerMutation = { __typename?: 'Mutation', assignPeer: { __typename?: 'MemberBenefitsMutationResponse', success: boolean, message: string, memberBenefits?: { __typename?: 'MemberBenefits', id: number, peer?: { __typename?: 'DashboardUser', id: number, name: string } | null } | { __typename?: 'ValidationErrors' } | null } };

export type UnassignPeerMutationVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type UnassignPeerMutation = { __typename?: 'Mutation', unassignPeer: { __typename?: 'MemberBenefitsMutationResponse', success: boolean, message: string, memberBenefits?: { __typename?: 'MemberBenefits', id: number, peer?: { __typename?: 'DashboardUser', id: number, name: string } | null } | { __typename?: 'ValidationErrors' } | null } };

export type CreateWellnessGoalMutationVariables = Exact<{
  memberId: Scalars['Int']['input'];
  input: WellnessGoalInput;
}>;


export type CreateWellnessGoalMutation = { __typename?: 'Mutation', createWellnessGoal: { __typename?: 'WellnessGoalMutationResponse', success: boolean, message: string } };

export type UpdateWellnessGoalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: WellnessGoalInput;
}>;


export type UpdateWellnessGoalMutation = { __typename?: 'Mutation', updateWellnessGoal: { __typename?: 'WellnessGoalMutationResponse', success: boolean, message: string, wellnessGoal?: { __typename?: 'ValidationErrors' } | (
      { __typename?: 'WellnessGoal' }
      & { ' $fragmentRefs'?: { 'WellnessGoalFragment': WellnessGoalFragment } }
    ) | null } };

export type DeleteWellnessGoalMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteWellnessGoalMutation = { __typename?: 'Mutation', deleteWellnessGoal: { __typename?: 'WellnessGoalMutationResponse', success: boolean, message: string, wellnessGoal?: { __typename?: 'ValidationErrors' } | { __typename?: 'WellnessGoal', id: number } | null } };

export type ContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContractsQuery = { __typename?: 'Query', contracts: Array<(
    { __typename?: 'Contract' }
    & { ' $fragmentRefs'?: { 'ContractFragment': ContractFragment } }
  )> };

export type CreateContractMutationVariables = Exact<{
  input: ContractInput;
}>;


export type CreateContractMutation = { __typename?: 'Mutation', createContractV2: { __typename?: 'ContractMutationResponse', success: boolean, message: string, contract?: (
      { __typename?: 'Contract' }
      & { ' $fragmentRefs'?: { 'ContractFragment': ContractFragment } }
    ) | { __typename?: 'ValidationErrors', validationErrors: Array<{ __typename?: 'ValidationError', field: string, errors: Array<string> }> } | null } };

export type UpdateContractMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ContractInput;
}>;


export type UpdateContractMutation = { __typename?: 'Mutation', updateContract: { __typename?: 'ContractMutationResponse', success: boolean, message: string, contract?: (
      { __typename?: 'Contract' }
      & { ' $fragmentRefs'?: { 'ContractFragment': ContractFragment } }
    ) | { __typename?: 'ValidationErrors', validationErrors: Array<{ __typename?: 'ValidationError', field: string, errors: Array<string> }> } | null } };

export type UpdateContractNotesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
}>;


export type UpdateContractNotesMutation = { __typename?: 'Mutation', updateContractNotes: { __typename?: 'ContractMutationResponse', success: boolean, message: string, contract?: (
      { __typename?: 'Contract' }
      & { ' $fragmentRefs'?: { 'ContractFragment': ContractFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type QueryEngagementsQueryVariables = Exact<{
  input: QueryEngagementsInput;
}>;


export type QueryEngagementsQuery = { __typename?: 'Query', queryEngagementsV2: { __typename?: 'QueryEngagementsResponse', totalCount: number, pageSize: number, page?: number | null, engagements: Array<(
      { __typename?: 'Engagement', member: { __typename?: 'Member', id: number, name?: string | null }, peer: { __typename?: 'DashboardUser', id: number, name: string } }
      & { ' $fragmentRefs'?: { 'EngagementFragment': EngagementFragment } }
    )> } };

export type QueryOutreachesQueryVariables = Exact<{
  input: QueryOutreachesInput;
}>;


export type QueryOutreachesQuery = { __typename?: 'Query', queryOutreaches: { __typename?: 'QueryOutreachesResponse', totalCount: number, pageSize: number, page?: number | null, outreaches: Array<(
      { __typename?: 'Outreach', member: { __typename?: 'Member', id: number, name?: string | null }, peer: { __typename?: 'DashboardUser', id: number, name: string } }
      & { ' $fragmentRefs'?: { 'OutreachFragment': OutreachFragment } }
    )> } };

export type CreateRewardsCodesMutationVariables = Exact<{
  input: CreateRewardsCodesInput;
}>;


export type CreateRewardsCodesMutation = { __typename?: 'Mutation', createRewardsCodes: { __typename?: 'CreateRewardsCodesResponse', success: boolean, message: string, rewardsCodes?: Array<{ __typename?: 'RewardsCode', id: number }> | null } };

export type CreateRewardsCodeMutationVariables = Exact<{
  input: CreateRewardsCodeInput;
}>;


export type CreateRewardsCodeMutation = { __typename?: 'Mutation', createRewardsCode: { __typename?: 'RewardsCodeMutationResponse', success: boolean, message: string, rewardsCode?: { __typename?: 'RewardsCode', id: number, code: string, redemptionLimit: number, redemptionsRemaining: number } | { __typename?: 'ValidationErrors' } | null } };

export type UpdateRewardsCodeMutationVariables = Exact<{
  input: UpdateRewardsCodeInput;
}>;


export type UpdateRewardsCodeMutation = { __typename?: 'Mutation', updateRewardsCode: { __typename?: 'RewardsCodeMutationResponse', success: boolean, message: string, rewardsCode?: { __typename?: 'RewardsCode', id: number, code: string, redemptionLimit: number, redemptionsRemaining: number, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number } | null } | { __typename?: 'ValidationErrors' } | null } };

export type UpdateRewardsCodesMutationVariables = Exact<{
  input: UpdateRewardsCodesInput;
}>;


export type UpdateRewardsCodesMutation = { __typename?: 'Mutation', updateRewardsCodes: { __typename?: 'RewardsCodesMutationResponse', success: boolean, message: string, rewardsCodes?: Array<{ __typename?: 'RewardsCode', id: number, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number } | null } | { __typename?: 'ValidationErrors' }> | null } };

export type DeleteRewardsCodesMutationVariables = Exact<{
  input: DeleteRewardsCodesInput;
}>;


export type DeleteRewardsCodesMutation = { __typename?: 'Mutation', deleteRewardsCodes: { __typename?: 'RewardsCodesMutationResponse', success: boolean, message: string } };

export type RewardsCodesQueryVariables = Exact<{
  input: RewardsCodesInput;
}>;


export type RewardsCodesQuery = { __typename?: 'Query', rewardsCodes: { __typename?: 'RewardsCodesResponse', page?: number | null, pageSize: number, order: Order, orderBy: RewardsCodesOrderBy, totalCount: number, rewardsCodes: Array<{ __typename?: 'RewardsCode', id: number, code: string, createdAt: DateTime, distributionMethod?: DistributionMethod | null, contract: { __typename?: 'Contract', id: number, name: string }, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number, name: string } | null }> } };

export type RewardsPlanFragment = { __typename?: 'RewardsPlan', id: number, name: string, createdAt: DateTime, activeMembers?: number | null, surveyAmount: number, barc10Amount: number, segments: Array<{ __typename?: 'RewardsPlanSegment', id: number, thresholdAmount: number, challengeStructure: { __typename?: 'ChallengeStructure', id: number, amount: number, duration?: number | null } }> } & { ' $fragmentName'?: 'RewardsPlanFragment' };

export type RewardsPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type RewardsPlansQuery = { __typename?: 'Query', rewardsPlans: Array<(
    { __typename?: 'RewardsPlan' }
    & { ' $fragmentRefs'?: { 'RewardsPlanFragment': RewardsPlanFragment } }
  )> };

export type EditRewardsPlanMutationVariables = Exact<{
  input: EditRewardsPlanInput;
}>;


export type EditRewardsPlanMutation = { __typename?: 'Mutation', editRewardsPlan: { __typename?: 'RewardsPlanResponse', success: boolean, message: string, rewardsPlan?: (
      { __typename?: 'RewardsPlan' }
      & { ' $fragmentRefs'?: { 'RewardsPlanFragment': RewardsPlanFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type CreateRewardsPlanMutationVariables = Exact<{
  input: CreateRewardsPlanInput;
}>;


export type CreateRewardsPlanMutation = { __typename?: 'Mutation', createRewardsPlan: { __typename?: 'RewardsPlanResponse', success: boolean, message: string, rewardsPlan?: (
      { __typename?: 'RewardsPlan' }
      & { ' $fragmentRefs'?: { 'RewardsPlanFragment': RewardsPlanFragment } }
    ) | { __typename?: 'ValidationErrors' } | null } };

export type TreatmentProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type TreatmentProvidersQuery = { __typename?: 'Query', treatmentProviders: Array<{ __typename?: 'TreatmentProvider', id: number, name: string, contract: { __typename?: 'Contract', id: number } }> };

export type CreateTreatmentProviderMutationVariables = Exact<{
  input: CreateTreatmentProviderInput;
}>;


export type CreateTreatmentProviderMutation = { __typename?: 'Mutation', createTreatmentProvider: { __typename?: 'TreatmentProviderMutationResponse', success: boolean, message: string, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number, name: string, contract: { __typename?: 'Contract', id: number, name: string } } | null } };

export type UpdateTreatmentProviderMutationVariables = Exact<{
  input: UpdateTreatmentProviderInput;
}>;


export type UpdateTreatmentProviderMutation = { __typename?: 'Mutation', updateTreatmentProvider: { __typename?: 'TreatmentProviderMutationResponse', success: boolean, message: string, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number, name: string } | null } };

export type DeleteTreatmentProviderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteTreatmentProviderMutation = { __typename?: 'Mutation', deleteTreatmentProvider: { __typename?: 'TreatmentProviderMutationResponse', success: boolean, message: string } };

export type UpdateDashboardUserMutationVariables = Exact<{
  input: UpdateDashboardUserInput;
}>;


export type UpdateDashboardUserMutation = { __typename?: 'Mutation', updateDashboardUser: { __typename?: 'UpdateDashboardUserResponse', success: boolean, message: string, dashboardUser?: { __typename: 'DashboardUser', id: number, role?: Role | null, active: boolean, bio?: string | null, bioSpanish?: string | null, pronouns?: string | null, calendarLink?: string | null } | { __typename: 'ValidationErrors' } | null } };

export type UpdateContractGiftCardsMutationVariables = Exact<{
  input: UpdateBrandKeysInput;
}>;


export type UpdateContractGiftCardsMutation = { __typename?: 'Mutation', updateBrandKeys: { __typename?: 'ContractMutationResponse', success: boolean, message: string, contract?: { __typename?: 'Contract', id: number, tangoBrandKeys: Array<string> } | { __typename?: 'ValidationErrors' } | null } };

export type MultiuseActivationCodesQueryVariables = Exact<{
  input: RewardsCodesInput;
}>;


export type MultiuseActivationCodesQuery = { __typename?: 'Query', multiuseRewardsCodes: { __typename?: 'RewardsCodesResponse', rewardsCodes: Array<{ __typename?: 'RewardsCode', id: number, redemptionLimit: number, code: string, redemptionsRemaining: number }> } };

export type ContractFragment = { __typename?: 'Contract', durationOfMessaging?: number | null, durationOfRewards?: number | null, id: number, name: string, type?: ContractType | null, planYearStartsAt?: DateTime | null, startingBalance: number, planYearEarningsLimit?: number | null, tangoBrandKeys: Array<string>, requiresReferral: boolean, rewardsPlanId?: number | null, endsAt?: DateTime | null, eligibleMemberCount?: number | null, enrollmentStartsAt?: DateTime | null, enrollmentEndsAt?: DateTime | null, notes?: string | null, rewardsPlan?: { __typename?: 'RewardsPlan', id: number, name: string } | null } & { ' $fragmentName'?: 'ContractFragment' };

export type FindContractQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FindContractQuery = { __typename?: 'Query', contract?: (
    { __typename?: 'Contract', treatmentProviders: Array<{ __typename?: 'TreatmentProvider', id: number, name: string }> }
    & { ' $fragmentRefs'?: { 'ContractFragment': ContractFragment } }
  ) | null };

export type GiftCardBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GiftCardBrandsQuery = { __typename?: 'Query', giftCardBrands: Array<{ __typename?: 'Brand', name: string, key: string, image: string }> };

export type CreateFeatureMutationMutationVariables = Exact<{
  input: CreateFeatureInput;
}>;


export type CreateFeatureMutationMutation = { __typename?: 'Mutation', createFeature?: { __typename?: 'CreateFeatureResponse', feature?: { __typename?: 'Feature', key: string, comment?: string | null, minVersion?: string | null } | null } | null };

export type FeatureFragment = { __typename?: 'Feature', key: string, comment?: string | null, minVersion?: string | null, rolloutPhase: RolloutPhase, retiredVersion?: string | null } & { ' $fragmentName'?: 'FeatureFragment' };

export type FeatureOverridesQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type FeatureOverridesQuery = { __typename?: 'Query', featureOverrides?: Array<{ __typename?: 'FeatureOverride', key: string, memberIds: Array<number> }> | null };

export type UpdateFeatureOverridesMutationVariables = Exact<{
  input: UpdateFeatureOverridesInput;
}>;


export type UpdateFeatureOverridesMutation = { __typename?: 'Mutation', updateFeatureOverrides?: { __typename?: 'UpdateFeatureOverridesResponse', key: string, memberIds: Array<number> } | null };

export type RetireFeataureMutationMutationVariables = Exact<{
  input: FeatureRetireInput;
}>;


export type RetireFeataureMutationMutation = { __typename?: 'Mutation', retireFeature: { __typename?: 'Feature', key: string, retiredVersion?: string | null } };

export type RolloutFeatureMutationMutationVariables = Exact<{
  input: FeatureRolloutInput;
}>;


export type RolloutFeatureMutationMutation = { __typename?: 'Mutation', rolloutFeature: { __typename?: 'Feature', key: string, rolloutPhase: RolloutPhase, minVersion?: string | null } };

export type GetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturesQuery = { __typename?: 'Query', features: Array<(
    { __typename?: 'Feature' }
    & { ' $fragmentRefs'?: { 'FeatureFragment': FeatureFragment } }
  )> };

export type CreateDashboardUserMutationVariables = Exact<{
  input: CreateDashboardUserInput;
}>;


export type CreateDashboardUserMutation = { __typename?: 'Mutation', createDashboardUser: { __typename?: 'CreateDashboardUserResponse', success: boolean, message: string } };

export type DashboardUserFragment = { __typename?: 'DashboardUser', id: number, name: string, email: string, role?: Role | null, active: boolean } & { ' $fragmentName'?: 'DashboardUserFragment' };

export type DashboardUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardUsersQuery = { __typename?: 'Query', dashboardUsers: Array<(
    { __typename?: 'DashboardUser' }
    & { ' $fragmentRefs'?: { 'DashboardUserFragment': DashboardUserFragment } }
  )> };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestDashboardPasswordReset: { __typename?: 'RequestDashboardPasswordResetResponse', success: boolean, message: string } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPasswordForDashboardUser: { __typename?: 'ResetPasswordMutationResponse', success: boolean, message: string, session?: { __typename?: 'Session', jwt: string } | { __typename?: 'ValidationErrors' } | null } };

export type DeletedMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type DeletedMessagesQuery = { __typename?: 'Query', deletedMessages: Array<{ __typename?: 'DeletedMessage', id: number, messageText: string, messageSentAt: DateTime, deletedAt: DateTime, sentBy: { __typename?: 'DashboardUser', id: number, name: string }, receivedBy: { __typename?: 'Member', id: number, name?: string | null } }> };

export type IntakeFragment = { __typename?: 'Intake', id: number, updatedAt: DateTime, engagementFrequency?: number | null, engagementFrequencyInterval?: IntakeEngagementFrequencyInterval | null, complementaryRecoveryPlan?: string | null, hopesAndDreams?: string | null, strengthsAndInterests?: string | null, notes?: string | null, textOkay?: boolean | null, voicemailOkay?: boolean | null, contactNotes?: string | null, supportivePeople: Array<{ __typename?: 'SupportivePerson', id: number, name: string, relationship?: string | null }> } & { ' $fragmentName'?: 'IntakeFragment' };

export type UpdateIntakeMutationVariables = Exact<{
  memberId: Scalars['Int']['input'];
  input: IntakeInput;
}>;


export type UpdateIntakeMutation = { __typename?: 'Mutation', updateIntake: { __typename?: 'MemberMutationResponse', success: boolean, message: string, member?: { __typename?: 'Member', id: number, intake?: (
        { __typename?: 'Intake' }
        & { ' $fragmentRefs'?: { 'IntakeFragment': IntakeFragment } }
      ) | null } | { __typename?: 'ValidationErrors' } | null } };

export type UpdateStrengthsMutationVariables = Exact<{
  memberId: Scalars['Int']['input'];
  input: StrengthInput;
}>;


export type UpdateStrengthsMutation = { __typename?: 'Mutation', updateStrengths: { __typename?: 'MemberMutationResponse', success: boolean, message: string, member?: { __typename?: 'Member', id: number, strengths: Array<{ __typename?: 'Strength', id: number, prompt: string, responses: Array<{ __typename?: 'StrengthResponse', id: number, response: string }> }> } | { __typename?: 'ValidationErrors' } | null } };

export type ReleaseOfInformationFragment = { __typename?: 'ReleaseOfInformation', id: number, updatedAt: DateTime, status: RoiStatus, name?: string | null, relationship?: string | null, email?: string | null, phoneNumber?: string | null, url?: string | null } & { ' $fragmentName'?: 'ReleaseOfInformationFragment' };

export type RecoveryServicesQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type RecoveryServicesQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', id: number, releasesOfInformation: Array<(
      { __typename?: 'ReleaseOfInformation' }
      & { ' $fragmentRefs'?: { 'ReleaseOfInformationFragment': ReleaseOfInformationFragment } }
    )>, wellnessGoals: Array<(
      { __typename?: 'WellnessGoal' }
      & { ' $fragmentRefs'?: { 'WellnessGoalFragment': WellnessGoalFragment } }
    )>, intake?: (
      { __typename?: 'Intake' }
      & { ' $fragmentRefs'?: { 'IntakeFragment': IntakeFragment } }
    ) | null, strengths: Array<{ __typename?: 'Strength', id: number, prompt: string, responses: Array<{ __typename?: 'StrengthResponse', id: number, response: string }> }> } | null };

export type QueryChallengesQueryVariables = Exact<{
  input: QueryChallengesInput;
  memberId: Scalars['Int']['input'];
}>;


export type QueryChallengesQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', challenges: Array<{ __typename?: 'Challenge', id: number, number: number }> } | null, queryChallenges: { __typename?: 'QueryChallengesResponse', totalCount: number, page: number, pageSize: number, challenges: Array<{ __typename?: 'Challenge', id: number, number: number, completedAt?: DateTime | null, startsAt: DateTime, challengeName: string, earnedReward?: { __typename?: 'EarnedReward', createdAt: DateTime, amount: number } | null }> } };

export type QueryStandardSurveysQueryVariables = Exact<{
  input: QueryStandardSurveysInput;
}>;


export type QueryStandardSurveysQuery = { __typename?: 'Query', queryStandardSurveys: { __typename?: 'QueryStandardSurveysResponse', totalCount: number, page: number, pageSize: number, surveys: Array<{ __typename?: 'StandardSurveyV2', id: number, dateCompleted: DateTime, days: number, earnedReward?: { __typename?: 'EarnedReward', createdAt: DateTime, amount: number } | null }> } };

export type QueryRedeemedRewardsQueryVariables = Exact<{
  input: QueryRedeemedRewardsInput;
  memberId: Scalars['Int']['input'];
}>;


export type QueryRedeemedRewardsQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', rewardsBalance: number } | null, queryRedeemedRewards: { __typename?: 'QueryRedeemedRewardsResponse', totalCount: number, pageSize: number, page: number, rewards: Array<{ __typename?: 'RedeemedReward', id: number, amount: number, vendor?: string | null, createdAt: DateTime, purchasedAt?: DateTime | null }> } };

export type CategoryGroupsQueryVariables = Exact<{
  type?: InputMaybe<RoutineType>;
}>;


export type CategoryGroupsQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'RoutineCategoryGroup', id: number, name: CategoryGroup, title?: string | null, subtitle?: string | null, requirement: RoutineCreationRequirement, categories: Array<{ __typename?: 'Category', id: number, name: string, groupId: number, slug: string, groupName: CategoryGroup }> }> };

export type CreateRoutineV2MutationMutationVariables = Exact<{
  input: CreateRoutineV2Input;
}>;


export type CreateRoutineV2MutationMutation = { __typename?: 'Mutation', createRoutineV2: { __typename?: 'Routine', id: number } };

export type CreateBulkRoutineV2MutationMutationVariables = Exact<{
  input: CreateBulkRoutineV2Input;
}>;


export type CreateBulkRoutineV2MutationMutation = { __typename?: 'Mutation', createBulkRoutineV2?: { __typename?: 'CreateBulkRoutineV2Response', failedMemberIds: Array<number>, createdRoutines: Array<{ __typename?: 'Routine', id: number }> } | null };

export type DeleteRoutineMutationVariables = Exact<{
  input: DeleteRoutineV2Input;
}>;


export type DeleteRoutineMutation = { __typename?: 'Mutation', deleteRoutineV2: { __typename?: 'DeleteRoutineMutationResponse', success: boolean, message: string, routine?: { __typename?: 'Routine', id: number } | { __typename?: 'ValidationErrors', validationErrors: Array<{ __typename?: 'ValidationError', errors: Array<string>, field: string }> } | null } };

export type DeleteRecurrenceMutationVariables = Exact<{
  input: DeleteRecurrenceInputV2;
}>;


export type DeleteRecurrenceMutation = { __typename?: 'Mutation', deleteRecurrence: { __typename?: 'DeleteRecurrenceMutationResponse', success: boolean, message: string, routine?: { __typename?: 'Routine', id: number } | { __typename?: 'ValidationErrors', validationErrors: Array<{ __typename?: 'ValidationError', errors: Array<string>, field: string }> } | null } };

export type MemberRoutinesQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  memberId: Scalars['Int']['input'];
}>;


export type MemberRoutinesQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', id: number, routines: Array<{ __typename?: 'Routine', id: number, name: string, statusChanged?: DateTime | null, deletable?: boolean | null, recurrence: Array<string>, status: RoutineStatusType, origin: RoutineOrigin, type: RoutineType, category?: { __typename?: 'Category', id: number, name: string, groupName: CategoryGroup } | null }> } | null };

export type RoutineRecurrencesQueryVariables = Exact<{
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
  memberId: Scalars['Int']['input'];
  routineId: Scalars['Int']['input'];
}>;


export type RoutineRecurrencesQuery = { __typename?: 'Query', routine: { __typename?: 'Routine', id: number, recurrencesV2?: Array<{ __typename?: 'RecurrenceV3', uuid: string, name: string, recurrence: Array<string>, startsAt: DateTime, link?: string | null, anytime: boolean, location?: { __typename?: 'Location', id: number, name?: string | null, latitude: number, longitude: number, formattedAddress: string, timeZone: string } | null, checkin?: { __typename?: 'Checkin', id: number, date: DateTime, notPresentWarningSeen: boolean, timeWarningSeen: boolean, checkInAt?: DateTime | null, location?: { __typename?: 'CheckinLocation', latitude: number, longitude: number } | null } | null }> | null } };

export type Barc10QueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type Barc10Query = { __typename?: 'Query', getBarc10Surveys: Array<{ __typename?: 'Barc10Survey', score: number, date?: DateTime | null, id?: number | null, answers: Array<{ __typename?: 'barc10Answer', response: number, question?: { __typename?: 'Barc10Question', id: number, body: string } | null }> }> };

export type PeerSupportQuestionnaireQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type PeerSupportQuestionnaireQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', peerSupportQuestionnaire?: { __typename?: 'PeerSupportQuestionnaire', id: number, otherConcerns?: string | null, socialSupportSystem?: SocialSupportSystemResponse | null, priorTreatment?: PriorTreatmentResponse | null, considerations?: string | null, peerSupportAreas?: Array<{ __typename?: 'PeerSupportArea', id: number, name: string }> | null } | null } | null };

export type StandardSurveyQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type StandardSurveyQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', id: number, standardSurveys: Array<{ __typename?: 'StandardSurveyV2', id: number, days: number, feedbackHelps?: string | null, hasHelpedNPS: string, howSpentRewards?: Array<string> | null, lastDaysAttendedMeetings?: number | null, wouldRecommendNPS: string, biggestChallenge?: string | null, mostHelpfulForRecovery?: string | null }> } | null };

export type SurveyDisplayQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type SurveyDisplayQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', id: number, standardSurveys: Array<{ __typename?: 'StandardSurveyV2', id: number }>, peerSupportQuestionnaire?: { __typename?: 'PeerSupportQuestionnaire', id: number } | null } | null, getBarc10Surveys: Array<{ __typename?: 'Barc10Survey', id?: number | null }> };

export type FindMemberQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type FindMemberQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', id: number, accountStatus: AccountStatus, name?: string | null, preferredName?: string | null, email?: string | null, phoneNumber?: string | null, languageTag?: string | null, lastKnownTimeZone: string, birthDate?: DateTime | null, progressDate?: DateTime | null, engaged: boolean, mesNotes?: string | null, challenges: Array<{ __typename?: 'Challenge', challengeName: string }>, peerChangeRequest?: { __typename?: 'PeerChangeRequest', createdAt: DateTime, details?: string | null, peer?: { __typename?: 'DashboardUser', id: number, name: string } | null } | null, benefits?: { __typename?: 'MemberBenefits', maxPotentialRewards: number, messagingChannelUrl?: string | null, contract?: { __typename?: 'Contract', id: number, name: string } | null, peer?: { __typename?: 'DashboardUser', id: number, name: string } | null } | null, rewardsCode?: { __typename?: 'RewardsCode', code: string, distributionMethod?: DistributionMethod | null } | null, pronouns: Array<{ __typename?: 'Pronoun', id: number, name: string, customResponse?: string | null }>, contactPermissions: Array<{ __typename?: 'ContactPermission', id: number, name: string }>, subscription?: { __typename?: 'PaidSubscription', id: string, price?: { __typename?: 'Price', name?: string | null } | null } | null } | null };

export type AddToChannelMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type AddToChannelMutation = { __typename?: 'Mutation', addDashboardUserToChannel: { __typename?: 'AddDashboardUserToChannelResponse', success: boolean, message: string, url?: string | null } };

export type BulkLeaveConversationsMutationVariables = Exact<{
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkLeaveConversationsMutation = { __typename?: 'Mutation', removeDashboardUserFromChannels: { __typename?: 'RemoveDashboardUserFromChannelsResponse', success: boolean, message: string } };

export type BulkSendMessageMutationVariables = Exact<{
  input: SendMessageToMembersInput;
}>;


export type BulkSendMessageMutation = { __typename?: 'Mutation', sendMessageToMembers: { __typename?: 'SendMessageToMembersResponse', success: boolean, message: string } };

export type PeerPortalMembersQueryVariables = Exact<{
  input: QueryMembersInput;
}>;


export type PeerPortalMembersQuery = { __typename?: 'Query', queryMembers: { __typename?: 'QueryMembersResponse', order: Order, orderBy: QueryMembersOrderBy, page?: number | null, pageSize: number, totalCount: number, membersV2: Array<{ __typename?: 'Member', id: number, name?: string | null, createdAt: DateTime, totalEngagementDuration?: number | null, mesNotes?: string | null, languageTag?: string | null, lastOutreach?: DateTime | null, outreachCount: number, starred: boolean, peerChangeRequest?: { __typename?: 'PeerChangeRequest', createdAt: DateTime, peer?: { __typename?: 'DashboardUser', id: number, name: string } | null } | null, peerSupportQuestionnaire?: { __typename?: 'PeerSupportQuestionnaire', id: number } | null, checkins: Array<{ __typename?: 'Checkin', date: DateTime }>, contactPermissions: Array<{ __typename?: 'ContactPermission', id: number, name: string }>, benefits?: { __typename?: 'MemberBenefits', id: number, messagingChannelUrl?: string | null, messagingEndsAt?: DateTime | null, maxPotentialRewards: number, sentMessageCount?: number | null, channelLastReadAt?: DateTime | null, lastMessageSentAt?: DateTime | null, lastMessageSentBy?: MessageSentByRole | null, activatedAt: DateTime, peer?: { __typename?: 'DashboardUser', id: number, name: string } | null, contract?: { __typename?: 'Contract', id: number, name: string } | null } | null, wellnessGoals: Array<{ __typename?: 'WellnessGoal', id: number }> }> } };

export type UpdateStarredMutationVariables = Exact<{
  input: UpdateStarredInput;
}>;


export type UpdateStarredMutation = { __typename?: 'Mutation', updateStarred: { __typename?: 'MemberMutationResponse', success: boolean, message: string, member?: { __typename?: 'Member', id: number, starred: boolean } | { __typename?: 'ValidationErrors' } | null } };

export type ActiveAssignedMembersQueryVariables = Exact<{
  input: QueryMembersInput;
}>;


export type ActiveAssignedMembersQuery = { __typename?: 'Query', queryMembers: { __typename?: 'QueryMembersResponse', membersV2: Array<{ __typename?: 'Member', id: number, starred: boolean }> } };

export type UpdateAvailabilityHoursMutationVariables = Exact<{
  peerId?: InputMaybe<Scalars['Int']['input']>;
  input: AvailabilityHoursInput;
}>;


export type UpdateAvailabilityHoursMutation = { __typename?: 'Mutation', updateAvailabilityHours: { __typename?: 'UpdateDashboardUserResponse', success: boolean, message: string, dashboardUser?: { __typename?: 'DashboardUser', id: number, timeZone?: string | null, availabilityHours?: { __typename?: 'AvailabilityHours', id: number, startTime: DateTime, endTime: DateTime, recurrence: Array<string> } | null } | { __typename?: 'ValidationErrors' } | null } };

export type PeerEngagementDurationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type PeerEngagementDurationQuery = { __typename?: 'Query', peer?: { __typename?: 'DashboardUser', id: number, cumulativeEngagementDuration?: number | null } | null };

export type AuthorizeGoogleMutationVariables = Exact<{
  input: AuthorizeGoogleInput;
}>;


export type AuthorizeGoogleMutation = { __typename?: 'Mutation', authorizeGoogle: { __typename?: 'UpdateDashboardUserResponse', success: boolean, message: string, dashboardUser?: { __typename?: 'DashboardUser', id: number, googleConnected: boolean } | { __typename?: 'ValidationErrors' } | null } };

export type UpdateVacationMessageMutationVariables = Exact<{
  peerId?: InputMaybe<Scalars['Int']['input']>;
  input: VacationMessageInput;
}>;


export type UpdateVacationMessageMutation = { __typename?: 'Mutation', updateVacationMessage: { __typename?: 'UpdateDashboardUserResponse', success: boolean, message: string, dashboardUser?: { __typename?: 'DashboardUser', id: number, vacationMessage?: { __typename?: 'VacationMessage', id: number, active: boolean, text: string, textSpanish?: string | null } | null } | { __typename?: 'ValidationErrors' } | null } };

export type AuthorizeZoomMutationVariables = Exact<{
  input: AuthorizeZoomInput;
}>;


export type AuthorizeZoomMutation = { __typename?: 'Mutation', authorizeZoom: { __typename?: 'UpdateDashboardUserResponse', success: boolean, message: string, dashboardUser?: { __typename?: 'DashboardUser', id: number, zoomConnected: boolean } | { __typename?: 'ValidationErrors' } | null } };

export type FindPeerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FindPeerQuery = { __typename?: 'Query', peer?: { __typename?: 'DashboardUser', id: number, name: string, email: string, bio?: string | null, bioSpanish?: string | null, calendarLink?: string | null, googleConnected: boolean, zoomConnected: boolean, timeZone?: string | null, vacationMessage?: { __typename?: 'VacationMessage', id: number, active: boolean, text: string, textSpanish?: string | null } | null, availabilityHours?: { __typename?: 'AvailabilityHours', id: number, startTime: DateTime, endTime: DateTime, recurrence: Array<string> } | null, peerStateCertifications: Array<{ __typename?: 'PeerStateCertification', insuranceState: { __typename?: 'InsuranceState', id: number, name: string } }> } | null };

export type AllInsuranceStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllInsuranceStatesQuery = { __typename?: 'Query', insuranceStates: Array<{ __typename?: 'InsuranceState', id: number, name: string }> };

export type UpdatePeerStateCertificationsMutationVariables = Exact<{
  peerId: Scalars['Int']['input'];
  input: Array<PeerStateCertificationInput> | PeerStateCertificationInput;
}>;


export type UpdatePeerStateCertificationsMutation = { __typename?: 'Mutation', updatePeerStateCertifications: { __typename?: 'UpdateDashboardUserResponse', success: boolean } };

export type PeerStatsQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type PeerStatsQuery = { __typename?: 'Query', peerStats: Array<{ __typename?: 'DashboardUser', id: number, name: string, timeZone?: string | null, activeMemberCount?: number | null, engagedMemberCount?: number | null, inactiveMemberCount?: number | null, cumulativeEngagementDuration?: number | null }> };

export type QuerySupervisorEngagementsQueryVariables = Exact<{
  input: QueryEngagementsInput;
}>;


export type QuerySupervisorEngagementsQuery = { __typename?: 'Query', queryEngagementsV2: { __typename?: 'QueryEngagementsResponse', totalCount: number, totalMinutes: number, uniqueMemberCount: number, pageSize: number, page?: number | null, engagements: Array<{ __typename?: 'Engagement', id: number, successful: boolean, startedAt: DateTime, type: EngagementType, duration: number, member: { __typename?: 'Member', id: number, name?: string | null, benefits?: { __typename?: 'MemberBenefits', contract?: { __typename?: 'Contract', id: number, name: string } | null } | null }, peer: { __typename?: 'DashboardUser', id: number, name: string } }> } };

export type WellnessGoalRoutinesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  timeZone: Scalars['String']['input'];
}>;


export type WellnessGoalRoutinesQuery = { __typename?: 'Query', wellnessGoal?: { __typename?: 'WellnessGoal', id: number, routines: Array<{ __typename?: 'Routine', id: number, name: string, recurrence: Array<string>, link?: string | null, notes?: string | null, anytime: boolean, createdAt: DateTime, closestStartsAt: DateTime, category?: { __typename?: 'Category', id: number, name: string } | null, location?: { __typename?: 'Location', id: number, name?: string | null } | null, creationInfo?: { __typename?: 'RoutineCreationInfo', createdBy: string } | null, lastCheckin?: { __typename?: 'Checkin', id: number, date: DateTime } | null }> } | null };

export type WellnessGoalFragment = { __typename?: 'WellnessGoal', id: number, title: string, domain?: WellnessGoalDomain | null, status: WellnessGoalStatus, priorityLevel?: WellnessGoalPriorityLevel | null, description?: string | null, displayInApp: boolean, createdAt: DateTime, member: { __typename?: 'Member', id: number, name?: string | null }, dashboardUser?: { __typename?: 'DashboardUser', id: number, name: string } | null } & { ' $fragmentName'?: 'WellnessGoalFragment' };

export type QueryWellnessGoalsQueryVariables = Exact<{
  input: QueryWellnessGoalsInput;
}>;


export type QueryWellnessGoalsQuery = { __typename?: 'Query', queryWellnessGoals: Array<(
    { __typename?: 'WellnessGoal' }
    & { ' $fragmentRefs'?: { 'WellnessGoalFragment': WellnessGoalFragment } }
  )> };

export type PeersQueryVariables = Exact<{ [key: string]: never; }>;


export type PeersQuery = { __typename?: 'Query', peers: Array<{ __typename?: 'DashboardUser', id: number, name: string, active: boolean }> };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changeDashboardUserPassword: { __typename?: 'UpdateDashboardUserResponse', success: boolean, message: string } };

export type RewardsCodeQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RewardsCodeQuery = { __typename?: 'Query', rewardsCode?: { __typename?: 'RewardsCode', id: number, code: string, startingBalance?: number | null, contract: { __typename?: 'Contract', id: number, name: string } } | null };

export type LossOfEligibilityReportQueryVariables = Exact<{ [key: string]: never; }>;


export type LossOfEligibilityReportQuery = { __typename?: 'Query', lossOfEligibilityReport: Array<{ __typename?: 'Member', id: number, name?: string | null, birthDate?: DateTime | null, eligibilityLastChecked?: DateTime | null, hasActiveEligibility?: boolean | null, benefits?: { __typename?: 'MemberBenefits', id: number, contract?: { __typename?: 'Contract', id: number, name: string } | null } | null }> };

export type UpdateMembersBenefitsMutationMutationVariables = Exact<{
  input: UpdateMembersBenefitsInput;
}>;


export type UpdateMembersBenefitsMutationMutation = { __typename?: 'Mutation', updateMembersBenefits: Array<{ __typename?: 'Member', id: number, benefits?: { __typename?: 'MemberBenefits', id: number, maxPotentialRewards: number, messagingEndsAt?: DateTime | null, rewardsEndsAt?: DateTime | null } | null }> };

export type RewardsStatusHistoryQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type RewardsStatusHistoryQuery = { __typename?: 'Query', memberRewardsStatusAudits: Array<{ __typename?: 'Audit', id: number, value: string, createdAt: DateTime, updatedAt: DateTime, dashboardUser: { __typename?: 'DashboardUser', id: number, name: string } }> };

export type SetRewardsEnabledMutationMutationVariables = Exact<{
  input: SetRewardsEnabledInput;
}>;


export type SetRewardsEnabledMutationMutation = { __typename?: 'Mutation', setRewardsEnabled: { __typename?: 'SetRewardsEnabledResponse', memberV2: { __typename?: 'Member', id: number, rewardsEnabled: boolean } } };

export type TigersMemberShowQueryVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type TigersMemberShowQuery = { __typename?: 'Query', findMember?: { __typename?: 'Member', id: number, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, accountStatus: AccountStatus, birthDate?: DateTime | null, csNotes?: string | null, challenges: Array<{ __typename?: 'Challenge', id: number }>, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number, name: string } | null, benefits?: { __typename?: 'MemberBenefits', id: number, contract?: { __typename?: 'Contract', id: number, name: string } | null } | null, rewardsCode?: { __typename?: 'RewardsCode', id: number, code: string, createdAt: DateTime, distributionMethod?: DistributionMethod | null } | null, rewardsPlan?: { __typename?: 'RewardsPlan', id: number, name: string } | null, healthPlanInfo?: { __typename?: 'HealthPlanInfo', id: number, insuranceId: string, healthPlan: { __typename?: 'SupportedHealthPlan', id: number, name: string } } | null } | null };

export type DeleteMemberBenefitsMutationVariables = Exact<{
  input: DeleteMemberBenefitsInput;
}>;


export type DeleteMemberBenefitsMutation = { __typename?: 'Mutation', deleteMemberBenefits: { __typename?: 'MemberMutationResponse', message: string, success: boolean, member?: { __typename?: 'Member', id: number, benefits?: { __typename?: 'MemberBenefits', id: number } | null, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number } | null, rewardsCode?: { __typename?: 'RewardsCode', id: number } | null, rewardsPlan?: { __typename?: 'RewardsPlan', id: number } | null } | { __typename?: 'ValidationErrors', validationErrors: Array<{ __typename?: 'ValidationError', errors: Array<string> }> } | null } };

export type HealthPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthPlansQuery = { __typename?: 'Query', supportedHealthPlans: Array<{ __typename?: 'SupportedHealthPlan', id: number, name: string }> };

export type TigersMembersQueryVariables = Exact<{
  input: QueryMembersInput;
}>;


export type TigersMembersQuery = { __typename?: 'Query', queryMembers: { __typename?: 'QueryMembersResponse', order: Order, orderBy: QueryMembersOrderBy, page?: number | null, pageSize: number, totalCount: number, membersV2: Array<{ __typename?: 'Member', id: number, accountDeactivationDate?: DateTime | null, accountStatus: AccountStatus, createdAt: DateTime, name?: string | null, rewardsEnabled: boolean, totalEarned: number, benefits?: { __typename?: 'MemberBenefits', id: number, maxPotentialRewards: number, messagingEndsAt?: DateTime | null, rewardsEndsAt?: DateTime | null, contract?: { __typename?: 'Contract', id: number, name: string } | null } | null, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number, name: string } | null }> } };

export type SetAccountStatusMutationVariables = Exact<{
  input: SetAccountStatusInput;
}>;


export type SetAccountStatusMutation = { __typename?: 'Mutation', setAccountStatusV2: { __typename?: 'SetAccountStatusMutationResponse', success: boolean, message: string, member?: { __typename?: 'Member', id: number, accountStatus: AccountStatus, accountDeactivationDate?: DateTime | null } | null } };

export type UpdatePhoneNumberMutationVariables = Exact<{
  input: UpdatePhoneNumberInput;
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', updatePhoneNumber: { __typename?: 'UpdatePhoneNumberResponse', memberV2: { __typename?: 'Member', id: number, phoneNumber?: string | null } } };

export type UpdateMemberTreatmentProviderMutationVariables = Exact<{
  input: UpdateMemberTreatmentProviderInput;
}>;


export type UpdateMemberTreatmentProviderMutation = { __typename?: 'Mutation', updateMemberTreatmentProvider?: { __typename?: 'Member', id: number, name?: string | null, treatmentProvider?: { __typename?: 'TreatmentProvider', id: number, name: string } | null } | null };

export type UpgradeByAdminMutationVariables = Exact<{
  input: UpgradeByAdminInput;
}>;


export type UpgradeByAdminMutation = { __typename?: 'Mutation', upgradeByAdmin: { __typename?: 'MemberMutationResponse', message: string, success: boolean, member?: { __typename?: 'Member', id: number, benefits?: { __typename?: 'MemberBenefits', id: number, maxPotentialRewards: number, messagingEndsAt?: DateTime | null, rewardsEndsAt?: DateTime | null, contract?: { __typename?: 'Contract', id: number, name: string } | null } | null, rewardsPlan?: { __typename?: 'RewardsPlan', name: string } | null } | { __typename?: 'ValidationErrors', validationErrors: Array<{ __typename?: 'ValidationError', errors: Array<string>, field: string }> } | null } };

export type UpdateEligibilityInfoMutationVariables = Exact<{
  input: UpdateEligibilityInput;
}>;


export type UpdateEligibilityInfoMutation = { __typename?: 'Mutation', updateEligibilityInfo: { __typename?: 'MemberMutationResponse', success: boolean, message: string, member?: { __typename?: 'Member', id: number, name?: string | null, firstName?: string | null, lastName?: string | null, birthDate?: DateTime | null, healthPlanInfo?: { __typename?: 'HealthPlanInfo', id: number, insuranceId: string, healthPlan: { __typename?: 'SupportedHealthPlan', id: number, name: string } } | null } | { __typename?: 'ValidationErrors' } | null } };

export type UpdateNotesMutationVariables = Exact<{
  input: UpdateNotesInput;
}>;


export type UpdateNotesMutation = { __typename?: 'Mutation', updateNotes: { __typename?: 'MemberMutationResponse', success: boolean, message: string, member?: { __typename?: 'Member', id: number, csNotes?: string | null, mesNotes?: string | null } | { __typename?: 'ValidationErrors' } | null } };

export type ChallengeStructuresQueryVariables = Exact<{ [key: string]: never; }>;


export type ChallengeStructuresQuery = { __typename?: 'Query', challengeStructures: Array<{ __typename?: 'ChallengeStructure', id: number, amount: number, duration?: number | null }> };

export type SignInDashboardUserMutationVariables = Exact<{
  input: SignInDashboardUserInput;
}>;


export type SignInDashboardUserMutation = { __typename?: 'Mutation', signInDashboardUserV2: { __typename?: 'SignInDashboardUserResponseV2', success: boolean, message: string, session?: { __typename?: 'Session', jwt: string, sendbirdToken?: { __typename?: 'SessionToken', token: string, expiresAt: number } | null } | null, dashboardUser?: { __typename?: 'DashboardUser', id: number, firstName: string, role?: Role | null } | null } };

export const EngagementFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Engagement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"planChanges"}},{"kind":"Field","name":{"kind":"Name","value":"goalProgress"}},{"kind":"Field","name":{"kind":"Name","value":"referrals"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}}]} as unknown as DocumentNode<EngagementFragment, unknown>;
export const NotificationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountDeactivationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}}]}}]} as unknown as DocumentNode<NotificationFragment, unknown>;
export const OutreachFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Outreach"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Outreach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<OutreachFragment, unknown>;
export const RewardsPlanFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activeMembers"}},{"kind":"Field","name":{"kind":"Name","value":"surveyAmount"}},{"kind":"Field","name":{"kind":"Name","value":"barc10Amount"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"challengeStructure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thresholdAmount"}}]}}]}}]} as unknown as DocumentNode<RewardsPlanFragment, unknown>;
export const ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationOfMessaging"}},{"kind":"Field","name":{"kind":"Name","value":"durationOfRewards"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"planYearStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"planYearEarningsLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tangoBrandKeys"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReferral"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ContractFragment, unknown>;
export const FeatureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feature"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"minVersion"}},{"kind":"Field","name":{"kind":"Name","value":"rolloutPhase"}},{"kind":"Field","name":{"kind":"Name","value":"retiredVersion"}}]}}]} as unknown as DocumentNode<FeatureFragment, unknown>;
export const DashboardUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<DashboardUserFragment, unknown>;
export const IntakeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Intake"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Intake"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagementFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"engagementFrequencyInterval"}},{"kind":"Field","name":{"kind":"Name","value":"complementaryRecoveryPlan"}},{"kind":"Field","name":{"kind":"Name","value":"hopesAndDreams"}},{"kind":"Field","name":{"kind":"Name","value":"strengthsAndInterests"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"supportivePeople"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textOkay"}},{"kind":"Field","name":{"kind":"Name","value":"voicemailOkay"}},{"kind":"Field","name":{"kind":"Name","value":"contactNotes"}}]}}]} as unknown as DocumentNode<IntakeFragment, unknown>;
export const ReleaseOfInformationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReleaseOfInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseOfInformation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<ReleaseOfInformationFragment, unknown>;
export const WellnessGoalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WellnessGoal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayInApp"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<WellnessGoalFragment, unknown>;
export const TestQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TestQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<TestQueryQuery, TestQueryQueryVariables>;
export const LeaveChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeDashboardUserFromChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<LeaveChannelMutation, LeaveChannelMutationVariables>;
export const MemberConversationInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberConversationInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"messagingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MemberConversationInfoQuery, MemberConversationInfoQueryVariables>;
export const CreateEngagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEngagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Engagement"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Engagement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"planChanges"}},{"kind":"Field","name":{"kind":"Name","value":"goalProgress"}},{"kind":"Field","name":{"kind":"Name","value":"referrals"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}}]} as unknown as DocumentNode<CreateEngagementMutation, CreateEngagementMutationVariables>;
export const UpdateEngagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEngagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Engagement"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Engagement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"planChanges"}},{"kind":"Field","name":{"kind":"Name","value":"goalProgress"}},{"kind":"Field","name":{"kind":"Name","value":"referrals"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}}]} as unknown as DocumentNode<UpdateEngagementMutation, UpdateEngagementMutationVariables>;
export const DeleteEngagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEngagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteEngagementMutation, DeleteEngagementMutationVariables>;
export const NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Notifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryDashboardNotificationsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Notification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalUnseenCount"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Notification"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountDeactivationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}}]}}]} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const MarkNotificationsAsSeenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationsAsSeen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markDashboardNotificationsAsSeen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seen"}}]}}]}}]}}]} as unknown as DocumentNode<MarkNotificationsAsSeenMutation, MarkNotificationsAsSeenMutationVariables>;
export const CreateOutreachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOutreach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OutreachInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOutreach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"outreach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Outreach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Outreach"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Outreach"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Outreach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<CreateOutreachMutation, CreateOutreachMutationVariables>;
export const UpdateOutreachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOutreach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OutreachInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOutreach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"outreach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Outreach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Outreach"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Outreach"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Outreach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<UpdateOutreachMutation, UpdateOutreachMutationVariables>;
export const DeleteOutreachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOutreach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOutreach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"outreach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Outreach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOutreachMutation, DeleteOutreachMutationVariables>;
export const CreateReleaseOfInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReleaseOfInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseOfInformationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReleaseOfInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateReleaseOfInformationMutation, CreateReleaseOfInformationMutationVariables>;
export const UpdateReleaseOfInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReleaseOfInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseOfInformationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReleaseOfInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"releaseOfInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseOfInformation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReleaseOfInformation"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReleaseOfInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseOfInformation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]} as unknown as DocumentNode<UpdateReleaseOfInformationMutation, UpdateReleaseOfInformationMutationVariables>;
export const DeleteReleaseOfInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReleaseOfInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReleaseOfInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"releaseOfInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseOfInformation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteReleaseOfInformationMutation, DeleteReleaseOfInformationMutationVariables>;
export const AssignPeerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignPeer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignPeerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignPeer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"memberBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MemberBenefits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignPeerMutation, AssignPeerMutationVariables>;
export const UnassignPeerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnassignPeer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unassignPeer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"memberBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MemberBenefits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnassignPeerMutation, UnassignPeerMutationVariables>;
export const CreateWellnessGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWellnessGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWellnessGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateWellnessGoalMutation, CreateWellnessGoalMutationVariables>;
export const UpdateWellnessGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWellnessGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWellnessGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"wellnessGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WellnessGoal"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WellnessGoal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayInApp"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateWellnessGoalMutation, UpdateWellnessGoalMutationVariables>;
export const DeleteWellnessGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWellnessGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWellnessGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"wellnessGoal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteWellnessGoalMutation, DeleteWellnessGoalMutationVariables>;
export const ContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Contracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contract"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationOfMessaging"}},{"kind":"Field","name":{"kind":"Name","value":"durationOfRewards"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"planYearStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"planYearEarningsLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tangoBrandKeys"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReferral"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ContractsQuery, ContractsQueryVariables>;
export const CreateContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContractV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contract"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationOfMessaging"}},{"kind":"Field","name":{"kind":"Name","value":"durationOfRewards"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"planYearStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"planYearEarningsLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tangoBrandKeys"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReferral"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateContractMutation, CreateContractMutationVariables>;
export const UpdateContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contract"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationOfMessaging"}},{"kind":"Field","name":{"kind":"Name","value":"durationOfRewards"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"planYearStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"planYearEarningsLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tangoBrandKeys"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReferral"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateContractMutation, UpdateContractMutationVariables>;
export const UpdateContractNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContractNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContractNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contract"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationOfMessaging"}},{"kind":"Field","name":{"kind":"Name","value":"durationOfRewards"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"planYearStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"planYearEarningsLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tangoBrandKeys"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReferral"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateContractNotesMutation, UpdateContractNotesMutationVariables>;
export const QueryEngagementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryEngagements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryEngagementsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryEngagementsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"engagements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Engagement"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Engagement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"planChanges"}},{"kind":"Field","name":{"kind":"Name","value":"goalProgress"}},{"kind":"Field","name":{"kind":"Name","value":"referrals"}},{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}}]} as unknown as DocumentNode<QueryEngagementsQuery, QueryEngagementsQueryVariables>;
export const QueryOutreachesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryOutreaches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryOutreachesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryOutreaches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"outreaches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Outreach"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Outreach"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Outreach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<QueryOutreachesQuery, QueryOutreachesQueryVariables>;
export const CreateRewardsCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRewardsCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRewardsCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRewardsCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRewardsCodesMutation, CreateRewardsCodesMutationVariables>;
export const CreateRewardsCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRewardsCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRewardsCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRewardsCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionLimit"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionsRemaining"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateRewardsCodeMutation, CreateRewardsCodeMutationVariables>;
export const UpdateRewardsCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRewardsCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRewardsCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRewardsCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionLimit"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionsRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRewardsCodeMutation, UpdateRewardsCodeMutationVariables>;
export const UpdateRewardsCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRewardsCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRewardsCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRewardsCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsCode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRewardsCodesMutation, UpdateRewardsCodesMutationVariables>;
export const DeleteRewardsCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRewardsCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRewardsCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRewardsCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteRewardsCodesMutation, DeleteRewardsCodesMutationVariables>;
export const RewardsCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RewardsCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"orderBy"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RewardsCodesQuery, RewardsCodesQueryVariables>;
export const RewardsPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RewardsPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardsPlan"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activeMembers"}},{"kind":"Field","name":{"kind":"Name","value":"surveyAmount"}},{"kind":"Field","name":{"kind":"Name","value":"barc10Amount"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"challengeStructure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thresholdAmount"}}]}}]}}]} as unknown as DocumentNode<RewardsPlansQuery, RewardsPlansQueryVariables>;
export const EditRewardsPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditRewardsPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EditRewardsPlanInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editRewardsPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardsPlan"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activeMembers"}},{"kind":"Field","name":{"kind":"Name","value":"surveyAmount"}},{"kind":"Field","name":{"kind":"Name","value":"barc10Amount"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"challengeStructure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thresholdAmount"}}]}}]}}]} as unknown as DocumentNode<EditRewardsPlanMutation, EditRewardsPlanMutationVariables>;
export const CreateRewardsPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRewardsPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRewardsPlanInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRewardsPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardsPlan"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardsPlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"activeMembers"}},{"kind":"Field","name":{"kind":"Name","value":"surveyAmount"}},{"kind":"Field","name":{"kind":"Name","value":"barc10Amount"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"challengeStructure"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thresholdAmount"}}]}}]}}]} as unknown as DocumentNode<CreateRewardsPlanMutation, CreateRewardsPlanMutationVariables>;
export const TreatmentProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TreatmentProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"treatmentProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TreatmentProvidersQuery, TreatmentProvidersQueryVariables>;
export const CreateTreatmentProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTreatmentProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTreatmentProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTreatmentProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreatmentProvider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateTreatmentProviderMutation, CreateTreatmentProviderMutationVariables>;
export const UpdateTreatmentProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTreatmentProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTreatmentProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTreatmentProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TreatmentProvider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTreatmentProviderMutation, UpdateTreatmentProviderMutationVariables>;
export const DeleteTreatmentProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTreatmentProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTreatmentProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteTreatmentProviderMutation, DeleteTreatmentProviderMutationVariables>;
export const UpdateDashboardUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDashboardUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDashboardUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDashboardUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"bioSpanish"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"calendarLink"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDashboardUserMutation, UpdateDashboardUserMutationVariables>;
export const UpdateContractGiftCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContractGiftCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBrandKeysInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBrandKeys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tangoBrandKeys"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateContractGiftCardsMutation, UpdateContractGiftCardsMutationVariables>;
export const MultiuseActivationCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MultiuseActivationCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RewardsCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multiuseRewardsCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionLimit"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionsRemaining"}}]}}]}}]}}]} as unknown as DocumentNode<MultiuseActivationCodesQuery, MultiuseActivationCodesQueryVariables>;
export const FindContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Contract"}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"durationOfMessaging"}},{"kind":"Field","name":{"kind":"Name","value":"durationOfRewards"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"planYearStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"planYearEarningsLimit"}},{"kind":"Field","name":{"kind":"Name","value":"tangoBrandKeys"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReferral"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlanId"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"eligibleMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrollmentEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FindContractQuery, FindContractQueryVariables>;
export const GiftCardBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GiftCardBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"giftCardBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]} as unknown as DocumentNode<GiftCardBrandsQuery, GiftCardBrandsQueryVariables>;
export const CreateFeatureMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFeatureMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateFeatureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"minVersion"}}]}}]}}]}}]} as unknown as DocumentNode<CreateFeatureMutationMutation, CreateFeatureMutationMutationVariables>;
export const FeatureOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureOverrides"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureOverrides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"memberIds"}}]}}]}}]} as unknown as DocumentNode<FeatureOverridesQuery, FeatureOverridesQueryVariables>;
export const UpdateFeatureOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFeatureOverrides"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFeatureOverridesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFeatureOverrides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"memberIds"}}]}}]}}]} as unknown as DocumentNode<UpdateFeatureOverridesMutation, UpdateFeatureOverridesMutationVariables>;
export const RetireFeataureMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetireFeataureMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureRetireInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retireFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"retiredVersion"}}]}}]}}]} as unknown as DocumentNode<RetireFeataureMutationMutation, RetireFeataureMutationMutationVariables>;
export const RolloutFeatureMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RolloutFeatureMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureRolloutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rolloutFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"rolloutPhase"}},{"kind":"Field","name":{"kind":"Name","value":"minVersion"}}]}}]}}]} as unknown as DocumentNode<RolloutFeatureMutationMutation, RolloutFeatureMutationMutationVariables>;
export const GetFeaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Feature"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Feature"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Feature"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"minVersion"}},{"kind":"Field","name":{"kind":"Name","value":"rolloutPhase"}},{"kind":"Field","name":{"kind":"Name","value":"retiredVersion"}}]}}]} as unknown as DocumentNode<GetFeaturesQuery, GetFeaturesQueryVariables>;
export const CreateDashboardUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDashboardUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDashboardUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDashboardUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<CreateDashboardUserMutation, CreateDashboardUserMutationVariables>;
export const DashboardUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardUser"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<DashboardUsersQuery, DashboardUsersQueryVariables>;
export const RequestPasswordResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestPasswordReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestDashboardPasswordReset"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResetPasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPasswordForDashboardUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const DeletedMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeletedMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageText"}},{"kind":"Field","name":{"kind":"Name","value":"messageSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"receivedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DeletedMessagesQuery, DeletedMessagesQueryVariables>;
export const UpdateIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntakeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntake"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Intake"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Intake"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Intake"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagementFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"engagementFrequencyInterval"}},{"kind":"Field","name":{"kind":"Name","value":"complementaryRecoveryPlan"}},{"kind":"Field","name":{"kind":"Name","value":"hopesAndDreams"}},{"kind":"Field","name":{"kind":"Name","value":"strengthsAndInterests"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"supportivePeople"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textOkay"}},{"kind":"Field","name":{"kind":"Name","value":"voicemailOkay"}},{"kind":"Field","name":{"kind":"Name","value":"contactNotes"}}]}}]} as unknown as DocumentNode<UpdateIntakeMutation, UpdateIntakeMutationVariables>;
export const UpdateStrengthsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStrengths"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StrengthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStrengths"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strengths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateStrengthsMutation, UpdateStrengthsMutationVariables>;
export const RecoveryServicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecoveryServices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"releasesOfInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReleaseOfInformation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wellnessGoals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WellnessGoal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Intake"}}]}},{"kind":"Field","name":{"kind":"Name","value":"strengths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReleaseOfInformation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReleaseOfInformation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WellnessGoal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayInApp"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Intake"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Intake"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagementFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"engagementFrequencyInterval"}},{"kind":"Field","name":{"kind":"Name","value":"complementaryRecoveryPlan"}},{"kind":"Field","name":{"kind":"Name","value":"hopesAndDreams"}},{"kind":"Field","name":{"kind":"Name","value":"strengthsAndInterests"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"supportivePeople"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textOkay"}},{"kind":"Field","name":{"kind":"Name","value":"voicemailOkay"}},{"kind":"Field","name":{"kind":"Name","value":"contactNotes"}}]}}]} as unknown as DocumentNode<RecoveryServicesQuery, RecoveryServicesQueryVariables>;
export const QueryChallengesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryChallenges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryChallengesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challenges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"queryChallenges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"challenges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"challengeName"}},{"kind":"Field","name":{"kind":"Name","value":"earnedReward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryChallengesQuery, QueryChallengesQueryVariables>;
export const QueryStandardSurveysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryStandardSurveys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryStandardSurveysInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryStandardSurveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"surveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"earnedReward"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryStandardSurveysQuery, QueryStandardSurveysQueryVariables>;
export const QueryRedeemedRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryRedeemedRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryRedeemedRewardsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsBalance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"queryRedeemedRewards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}}]}}]}}]}}]} as unknown as DocumentNode<QueryRedeemedRewardsQuery, QueryRedeemedRewardsQueryVariables>;
export const CategoryGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CategoryGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoutineType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"requirement"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]} as unknown as DocumentNode<CategoryGroupsQuery, CategoryGroupsQueryVariables>;
export const CreateRoutineV2MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRoutineV2Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRoutineV2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRoutineV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRoutineV2MutationMutation, CreateRoutineV2MutationMutationVariables>;
export const CreateBulkRoutineV2MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBulkRoutineV2Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBulkRoutineV2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBulkRoutineV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failedMemberIds"}},{"kind":"Field","name":{"kind":"Name","value":"createdRoutines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBulkRoutineV2MutationMutation, CreateBulkRoutineV2MutationMutationVariables>;
export const DeleteRoutineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRoutine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRoutineV2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRoutineV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"routine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Routine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRoutineMutation, DeleteRoutineMutationVariables>;
export const DeleteRecurrenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRecurrence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRecurrenceInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRecurrence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"routine"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Routine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteRecurrenceMutation, DeleteRecurrenceMutationVariables>;
export const MemberRoutinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberRoutines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"routines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"statusChanged"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MemberRoutinesQuery, MemberRoutinesQueryVariables>;
export const RoutineRecurrencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoutineRecurrences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"routineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"routine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"routineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"routineId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recurrencesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"anytime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"notPresentWarningSeen"}},{"kind":"Field","name":{"kind":"Name","value":"timeWarningSeen"}},{"kind":"Field","name":{"kind":"Name","value":"checkInAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RoutineRecurrencesQuery, RoutineRecurrencesQueryVariables>;
export const Barc10Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BARC10"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBarc10Surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response"}}]}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<Barc10Query, Barc10QueryVariables>;
export const PeerSupportQuestionnaireDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PeerSupportQuestionnaire"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peerSupportQuestionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"peerSupportAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherConcerns"}},{"kind":"Field","name":{"kind":"Name","value":"socialSupportSystem"}},{"kind":"Field","name":{"kind":"Name","value":"priorTreatment"}},{"kind":"Field","name":{"kind":"Name","value":"considerations"}}]}}]}}]}}]} as unknown as DocumentNode<PeerSupportQuestionnaireQuery, PeerSupportQuestionnaireQueryVariables>;
export const StandardSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StandardSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardSurveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"days"}},{"kind":"Field","name":{"kind":"Name","value":"feedbackHelps"}},{"kind":"Field","name":{"kind":"Name","value":"hasHelpedNPS"}},{"kind":"Field","name":{"kind":"Name","value":"howSpentRewards"}},{"kind":"Field","name":{"kind":"Name","value":"lastDaysAttendedMeetings"}},{"kind":"Field","name":{"kind":"Name","value":"wouldRecommendNPS"}},{"kind":"Field","name":{"kind":"Name","value":"biggestChallenge"}},{"kind":"Field","name":{"kind":"Name","value":"mostHelpfulForRecovery"}}]}}]}}]}}]} as unknown as DocumentNode<StandardSurveyQuery, StandardSurveyQueryVariables>;
export const SurveyDisplayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SurveyDisplay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"standardSurveys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peerSupportQuestionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getBarc10Surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SurveyDisplayQuery, SurveyDisplayQueryVariables>;
export const FindMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preferredName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"lastKnownTimeZone"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"progressDate"}},{"kind":"Field","name":{"kind":"Name","value":"engaged"}},{"kind":"Field","name":{"kind":"Name","value":"mesNotes"}},{"kind":"Field","name":{"kind":"Name","value":"challenges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peerChangeRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxPotentialRewards"}},{"kind":"Field","name":{"kind":"Name","value":"messagingChannelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"customResponse"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindMemberQuery, FindMemberQueryVariables>;
export const AddToChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddToChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDashboardUserToChannel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<AddToChannelMutation, AddToChannelMutationVariables>;
export const BulkLeaveConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkLeaveConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"urls"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeDashboardUserFromChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"urls"},"value":{"kind":"Variable","name":{"kind":"Name","value":"urls"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<BulkLeaveConversationsMutation, BulkLeaveConversationsMutationVariables>;
export const BulkSendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkSendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendMessageToMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessageToMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<BulkSendMessageMutation, BulkSendMessageMutationVariables>;
export const PeerPortalMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PeerPortalMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"orderBy"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"membersV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalEngagementDuration"}},{"kind":"Field","name":{"kind":"Name","value":"mesNotes"}},{"kind":"Field","name":{"kind":"Name","value":"languageTag"}},{"kind":"Field","name":{"kind":"Name","value":"lastOutreach"}},{"kind":"Field","name":{"kind":"Name","value":"outreachCount"}},{"kind":"Field","name":{"kind":"Name","value":"starred"}},{"kind":"Field","name":{"kind":"Name","value":"peerChangeRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"peerSupportQuestionnaire"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messagingChannelUrl"}},{"kind":"Field","name":{"kind":"Name","value":"messagingEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"maxPotentialRewards"}},{"kind":"Field","name":{"kind":"Name","value":"sentMessageCount"}},{"kind":"Field","name":{"kind":"Name","value":"channelLastReadAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageSentBy"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"wellnessGoals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PeerPortalMembersQuery, PeerPortalMembersQueryVariables>;
export const UpdateStarredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStarred"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateStarredInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStarred"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starred"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateStarredMutation, UpdateStarredMutationVariables>;
export const ActiveAssignedMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveAssignedMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membersV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"starred"}}]}}]}}]}}]} as unknown as DocumentNode<ActiveAssignedMembersQuery, ActiveAssignedMembersQueryVariables>;
export const UpdateAvailabilityHoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAvailabilityHours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AvailabilityHoursInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAvailabilityHours"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAvailabilityHoursMutation, UpdateAvailabilityHoursMutationVariables>;
export const PeerEngagementDurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PeerEngagementDuration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeEngagementDuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}]}}]}}]} as unknown as DocumentNode<PeerEngagementDurationQuery, PeerEngagementDurationQueryVariables>;
export const AuthorizeGoogleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthorizeGoogle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorizeGoogleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizeGoogle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"googleConnected"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthorizeGoogleMutation, AuthorizeGoogleMutationVariables>;
export const UpdateVacationMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVacationMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VacationMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVacationMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vacationMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textSpanish"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateVacationMessageMutation, UpdateVacationMessageMutationVariables>;
export const AuthorizeZoomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthorizeZoom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorizeZoomInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizeZoom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"zoomConnected"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthorizeZoomMutation, AuthorizeZoomMutationVariables>;
export const FindPeerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindPeer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"bio"}},{"kind":"Field","name":{"kind":"Name","value":"bioSpanish"}},{"kind":"Field","name":{"kind":"Name","value":"calendarLink"}},{"kind":"Field","name":{"kind":"Name","value":"googleConnected"}},{"kind":"Field","name":{"kind":"Name","value":"zoomConnected"}},{"kind":"Field","name":{"kind":"Name","value":"vacationMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"textSpanish"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availabilityHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peerStateCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}}]}}]} as unknown as DocumentNode<FindPeerQuery, FindPeerQueryVariables>;
export const AllInsuranceStatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllInsuranceStates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceStates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AllInsuranceStatesQuery, AllInsuranceStatesQueryVariables>;
export const UpdatePeerStateCertificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePeerStateCertifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"peerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PeerStateCertificationInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePeerStateCertifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"peerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"peerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdatePeerStateCertificationsMutation, UpdatePeerStateCertificationsMutationVariables>;
export const PeerStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PeerStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peerStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"activeMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"engagedMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"inactiveMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeEngagementDuration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start"}}},{"kind":"Argument","name":{"kind":"Name","value":"end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end"}}}]}]}}]}}]} as unknown as DocumentNode<PeerStatsQuery, PeerStatsQueryVariables>;
export const QuerySupervisorEngagementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QuerySupervisorEngagements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryEngagementsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryEngagementsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueMemberCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"engagements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"peer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QuerySupervisorEngagementsQuery, QuerySupervisorEngagementsQueryVariables>;
export const WellnessGoalRoutinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WellnessGoalRoutines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wellnessGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"routines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"anytime"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creationInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"closestStartsAt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeZone"}}}]},{"kind":"Field","name":{"kind":"Name","value":"lastCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]}}]} as unknown as DocumentNode<WellnessGoalRoutinesQuery, WellnessGoalRoutinesQueryVariables>;
export const QueryWellnessGoalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryWellnessGoals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryWellnessGoalsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryWellnessGoals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WellnessGoal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WellnessGoal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WellnessGoal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayInApp"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<QueryWellnessGoalsQuery, QueryWellnessGoalsQueryVariables>;
export const PeersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Peers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<PeersQuery, PeersQueryVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeDashboardUserPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const RewardsCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RewardsCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewardsCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startingBalance"}}]}}]}}]} as unknown as DocumentNode<RewardsCodeQuery, RewardsCodeQueryVariables>;
export const LossOfEligibilityReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LossOfEligibilityReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lossOfEligibilityReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"eligibilityLastChecked"}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveEligibility"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LossOfEligibilityReportQuery, LossOfEligibilityReportQueryVariables>;
export const UpdateMembersBenefitsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMembersBenefitsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMembersBenefitsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMembersBenefits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxPotentialRewards"}},{"kind":"Field","name":{"kind":"Name","value":"messagingEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsEndsAt"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMembersBenefitsMutationMutation, UpdateMembersBenefitsMutationMutationVariables>;
export const RewardsStatusHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RewardsStatusHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberRewardsStatusAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<RewardsStatusHistoryQuery, RewardsStatusHistoryQueryVariables>;
export const SetRewardsEnabledMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetRewardsEnabledMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetRewardsEnabledInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setRewardsEnabled"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<SetRewardsEnabledMutationMutation, SetRewardsEnabledMutationMutationVariables>;
export const TigersMemberShowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TigersMemberShow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"csNotes"}},{"kind":"Field","name":{"kind":"Name","value":"challenges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"healthPlanInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceId"}},{"kind":"Field","name":{"kind":"Name","value":"healthPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TigersMemberShowQuery, TigersMemberShowQueryVariables>;
export const DeleteMemberBenefitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMemberBenefits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteMemberBenefitsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMemberBenefits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardsCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteMemberBenefitsMutation, DeleteMemberBenefitsMutationVariables>;
export const HealthPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HealthPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedHealthPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<HealthPlansQuery, HealthPlansQueryVariables>;
export const TigersMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TigersMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"orderBy"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"pageSize"}},{"kind":"Field","name":{"kind":"Name","value":"membersV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountDeactivationDate"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"totalEarned"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxPotentialRewards"}},{"kind":"Field","name":{"kind":"Name","value":"messagingEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<TigersMembersQuery, TigersMembersQueryVariables>;
export const SetAccountStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetAccountStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetAccountStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setAccountStatusV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"accountDeactivationDate"}}]}}]}}]}}]} as unknown as DocumentNode<SetAccountStatusMutation, SetAccountStatusMutationVariables>;
export const UpdatePhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePhoneNumberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const UpdateMemberTreatmentProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberTreatmentProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMemberTreatmentProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberTreatmentProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"treatmentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMemberTreatmentProviderMutation, UpdateMemberTreatmentProviderMutationVariables>;
export const UpgradeByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpgradeByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpgradeByAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradeByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maxPotentialRewards"}},{"kind":"Field","name":{"kind":"Name","value":"messagingEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rewardsPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationErrors"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpgradeByAdminMutation, UpgradeByAdminMutationVariables>;
export const UpdateEligibilityInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEligibilityInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEligibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEligibilityInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"healthPlanInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceId"}},{"kind":"Field","name":{"kind":"Name","value":"healthPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEligibilityInfoMutation, UpdateEligibilityInfoMutationVariables>;
export const UpdateNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateNotesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"member"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Member"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"csNotes"}},{"kind":"Field","name":{"kind":"Name","value":"mesNotes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateNotesMutation, UpdateNotesMutationVariables>;
export const ChallengeStructuresDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChallengeStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeStructures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}}]} as unknown as DocumentNode<ChallengeStructuresQuery, ChallengeStructuresQueryVariables>;
export const SignInDashboardUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignInDashboardUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignInDashboardUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signInDashboardUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jwt"}},{"kind":"Field","name":{"kind":"Name","value":"sendbirdToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dashboardUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<SignInDashboardUserMutation, SignInDashboardUserMutationVariables>;